webpackJsonp([1],{

/***/ 1059:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_report_sale_js__ = __webpack_require__(1170);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c762a376_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_vue__ = __webpack_require__(1260);
var normalizeComponent = __webpack_require__(193)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_report_sale_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c762a376_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);



// axios.defaults.timeout = 3000
// var TimeoutReq = {timeout: 60 * 5 * 1000}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  PrintsendShiftHost: function PrintsendShiftHost(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  salePosDetail: function salePosDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDetail: function saleDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleCreditDetail: function saleCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/credit/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleHoldDetail: function saleHoldDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleSummary: function saleSummary(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseReport: function expenseReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/expense', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseIncome: function expenseIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/income', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  profitReport: function profitReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  dailyReport: function dailyReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/send/shift', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  stockReport: function stockReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/stock/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  movementReport: function movementReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/tran/item/section', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByCus: function holdingByCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByPaybill: function holdingByPaybill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/paybill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByRemain: function holdingByRemain(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleType: function saleType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDocType: function saleDocType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/sale/doctype/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleByItem: function saleByItem(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/group/begin', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportSaleCustomer: function reportSaleCustomer(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportHoldbillInvoice: function reportHoldbillInvoice(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/invoice', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardReport: function StandardReport(URL, header, body, success, error) {
    console.log(body);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/v2/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardCostReport: function StandardCostReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/item/cost/standard', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

/*!
* sweetalert2 v9.17.2
* Released under the MIT License.
*/
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Sweetalert2 = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  var consolePrefix = 'SweetAlert2:';
  /**
   * Filter the unique values into a new array
   * @param arr
   */

  var uniqueArray = function uniqueArray(arr) {
    var result = [];

    for (var i = 0; i < arr.length; i++) {
      if (result.indexOf(arr[i]) === -1) {
        result.push(arr[i]);
      }
    }

    return result;
  };
  /**
   * Capitalize the first letter of a string
   * @param str
   */

  var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  /**
   * Returns the array of object values (Object.values isn't supported in IE11)
   * @param obj
   */

  var objectValues = function objectValues(obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  };
  /**
   * Convert NodeList to Array
   * @param nodeList
   */

  var toArray = function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  };
  /**
   * Standardise console warnings
   * @param message
   */

  var warn = function warn(message) {
    console.warn("".concat(consolePrefix, " ").concat(message));
  };
  /**
   * Standardise console errors
   * @param message
   */

  var error = function error(message) {
    console.error("".concat(consolePrefix, " ").concat(message));
  };
  /**
   * Private global state for `warnOnce`
   * @type {Array}
   * @private
   */

  var previousWarnOnceMessages = [];
  /**
   * Show a console warning, but only if it hasn't already been shown
   * @param message
   */

  var warnOnce = function warnOnce(message) {
    if (!(previousWarnOnceMessages.indexOf(message) !== -1)) {
      previousWarnOnceMessages.push(message);
      warn(message);
    }
  };
  /**
   * Show a one-time console warning about deprecated params/methods
   */

  var warnAboutDepreation = function warnAboutDepreation(deprecatedParam, useInstead) {
    warnOnce("\"".concat(deprecatedParam, "\" is deprecated and will be removed in the next major release. Please use \"").concat(useInstead, "\" instead."));
  };
  /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   * @param arg
   */

  var callIfFunction = function callIfFunction(arg) {
    return typeof arg === 'function' ? arg() : arg;
  };
  var hasToPromiseFn = function hasToPromiseFn(arg) {
    return arg && typeof arg.toPromise === 'function';
  };
  var asPromise = function asPromise(arg) {
    return hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
  };
  var isPromise = function isPromise(arg) {
    return arg && Promise.resolve(arg) === arg;
  };

  var DismissReason = Object.freeze({
    cancel: 'cancel',
    backdrop: 'backdrop',
    close: 'close',
    esc: 'esc',
    timer: 'timer'
  });

  var isJqueryElement = function isJqueryElement(elem) {
    return _typeof(elem) === 'object' && elem.jquery;
  };

  var isElement = function isElement(elem) {
    return elem instanceof Element || isJqueryElement(elem);
  };

  var argsToParams = function argsToParams(args) {
    var params = {};

    if (_typeof(args[0]) === 'object' && !isElement(args[0])) {
      _extends(params, args[0]);
    } else {
      ['title', 'html', 'icon'].forEach(function (name, index) {
        var arg = args[index];

        if (typeof arg === 'string' || isElement(arg)) {
          params[name] = arg;
        } else if (arg !== undefined) {
          error("Unexpected type of ".concat(name, "! Expected \"string\" or \"Element\", got ").concat(_typeof(arg)));
        }
      });
    }

    return params;
  };

  var swalPrefix = 'swal2-';
  var prefix = function prefix(items) {
    var result = {};

    for (var i in items) {
      result[items[i]] = swalPrefix + items[i];
    }

    return result;
  };
  var swalClasses = prefix(['container', 'shown', 'height-auto', 'iosfix', 'popup', 'modal', 'no-backdrop', 'no-transition', 'toast', 'toast-shown', 'toast-column', 'show', 'hide', 'close', 'title', 'header', 'content', 'html-container', 'actions', 'confirm', 'cancel', 'footer', 'icon', 'icon-content', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'label', 'textarea', 'inputerror', 'validation-message', 'progress-steps', 'active-progress-step', 'progress-step', 'progress-step-line', 'loading', 'styled', 'top', 'top-start', 'top-end', 'top-left', 'top-right', 'center', 'center-start', 'center-end', 'center-left', 'center-right', 'bottom', 'bottom-start', 'bottom-end', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen', 'rtl', 'timer-progress-bar', 'timer-progress-bar-container', 'scrollbar-measure', 'icon-success', 'icon-warning', 'icon-info', 'icon-question', 'icon-error']);
  var iconTypes = prefix(['success', 'warning', 'info', 'question', 'error']);

  var getContainer = function getContainer() {
    return document.body.querySelector(".".concat(swalClasses.container));
  };
  var elementBySelector = function elementBySelector(selectorString) {
    var container = getContainer();
    return container ? container.querySelector(selectorString) : null;
  };

  var elementByClass = function elementByClass(className) {
    return elementBySelector(".".concat(className));
  };

  var getPopup = function getPopup() {
    return elementByClass(swalClasses.popup);
  };
  var getIcons = function getIcons() {
    var popup = getPopup();
    return toArray(popup.querySelectorAll(".".concat(swalClasses.icon)));
  };
  var getIcon = function getIcon() {
    var visibleIcon = getIcons().filter(function (icon) {
      return isVisible(icon);
    });
    return visibleIcon.length ? visibleIcon[0] : null;
  };
  var getTitle = function getTitle() {
    return elementByClass(swalClasses.title);
  };
  var getContent = function getContent() {
    return elementByClass(swalClasses.content);
  };
  var getHtmlContainer = function getHtmlContainer() {
    return elementByClass(swalClasses['html-container']);
  };
  var getImage = function getImage() {
    return elementByClass(swalClasses.image);
  };
  var getProgressSteps = function getProgressSteps() {
    return elementByClass(swalClasses['progress-steps']);
  };
  var getValidationMessage = function getValidationMessage() {
    return elementByClass(swalClasses['validation-message']);
  };
  var getConfirmButton = function getConfirmButton() {
    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.confirm));
  };
  var getCancelButton = function getCancelButton() {
    return elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.cancel));
  };
  var getActions = function getActions() {
    return elementByClass(swalClasses.actions);
  };
  var getHeader = function getHeader() {
    return elementByClass(swalClasses.header);
  };
  var getFooter = function getFooter() {
    return elementByClass(swalClasses.footer);
  };
  var getTimerProgressBar = function getTimerProgressBar() {
    return elementByClass(swalClasses['timer-progress-bar']);
  };
  var getCloseButton = function getCloseButton() {
    return elementByClass(swalClasses.close);
  }; // https://github.com/jkup/focusable/blob/master/index.js

  var focusable = "\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex=\"0\"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n";
  var getFocusableElements = function getFocusableElements() {
    var focusableElementsWithTabindex = toArray(getPopup().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')) // sort according to tabindex
    .sort(function (a, b) {
      a = parseInt(a.getAttribute('tabindex'));
      b = parseInt(b.getAttribute('tabindex'));

      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }

      return 0;
    });
    var otherFocusableElements = toArray(getPopup().querySelectorAll(focusable)).filter(function (el) {
      return el.getAttribute('tabindex') !== '-1';
    });
    return uniqueArray(focusableElementsWithTabindex.concat(otherFocusableElements)).filter(function (el) {
      return isVisible(el);
    });
  };
  var isModal = function isModal() {
    return !isToast() && !document.body.classList.contains(swalClasses['no-backdrop']);
  };
  var isToast = function isToast() {
    return document.body.classList.contains(swalClasses['toast-shown']);
  };
  var isLoading = function isLoading() {
    return getPopup().hasAttribute('data-loading');
  };

  var states = {
    previousBodyPadding: null
  };
  var setInnerHtml = function setInnerHtml(elem, html) {
    // #1926
    elem.textContent = '';

    if (html) {
      var parser = new DOMParser();
      var parsed = parser.parseFromString(html, "text/html");
      toArray(parsed.querySelector('head').childNodes).forEach(function (child) {
        elem.appendChild(child);
      });
      toArray(parsed.querySelector('body').childNodes).forEach(function (child) {
        elem.appendChild(child);
      });
    }
  };
  var hasClass = function hasClass(elem, className) {
    if (!className) {
      return false;
    }

    var classList = className.split(/\s+/);

    for (var i = 0; i < classList.length; i++) {
      if (!elem.classList.contains(classList[i])) {
        return false;
      }
    }

    return true;
  };

  var removeCustomClasses = function removeCustomClasses(elem, params) {
    toArray(elem.classList).forEach(function (className) {
      if (!(objectValues(swalClasses).indexOf(className) !== -1) && !(objectValues(iconTypes).indexOf(className) !== -1) && !(objectValues(params.showClass).indexOf(className) !== -1)) {
        elem.classList.remove(className);
      }
    });
  };

  var applyCustomClass = function applyCustomClass(elem, params, className) {
    removeCustomClasses(elem, params);

    if (params.customClass && params.customClass[className]) {
      if (typeof params.customClass[className] !== 'string' && !params.customClass[className].forEach) {
        return warn("Invalid type of customClass.".concat(className, "! Expected string or iterable object, got \"").concat(_typeof(params.customClass[className]), "\""));
      }

      addClass(elem, params.customClass[className]);
    }
  };
  function getInput(content, inputType) {
    if (!inputType) {
      return null;
    }

    switch (inputType) {
      case 'select':
      case 'textarea':
      case 'file':
        return getChildByClass(content, swalClasses[inputType]);

      case 'checkbox':
        return content.querySelector(".".concat(swalClasses.checkbox, " input"));

      case 'radio':
        return content.querySelector(".".concat(swalClasses.radio, " input:checked")) || content.querySelector(".".concat(swalClasses.radio, " input:first-child"));

      case 'range':
        return content.querySelector(".".concat(swalClasses.range, " input"));

      default:
        return getChildByClass(content, swalClasses.input);
    }
  }
  var focusInput = function focusInput(input) {
    input.focus(); // place cursor at end of text in text input

    if (input.type !== 'file') {
      // http://stackoverflow.com/a/2345915
      var val = input.value;
      input.value = '';
      input.value = val;
    }
  };
  var toggleClass = function toggleClass(target, classList, condition) {
    if (!target || !classList) {
      return;
    }

    if (typeof classList === 'string') {
      classList = classList.split(/\s+/).filter(Boolean);
    }

    classList.forEach(function (className) {
      if (target.forEach) {
        target.forEach(function (elem) {
          condition ? elem.classList.add(className) : elem.classList.remove(className);
        });
      } else {
        condition ? target.classList.add(className) : target.classList.remove(className);
      }
    });
  };
  var addClass = function addClass(target, classList) {
    toggleClass(target, classList, true);
  };
  var removeClass = function removeClass(target, classList) {
    toggleClass(target, classList, false);
  };
  var getChildByClass = function getChildByClass(elem, className) {
    for (var i = 0; i < elem.childNodes.length; i++) {
      if (hasClass(elem.childNodes[i], className)) {
        return elem.childNodes[i];
      }
    }
  };
  var applyNumericalStyle = function applyNumericalStyle(elem, property, value) {
    if (value || parseInt(value) === 0) {
      elem.style[property] = typeof value === 'number' ? "".concat(value, "px") : value;
    } else {
      elem.style.removeProperty(property);
    }
  };
  var show = function show(elem) {
    var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
    elem.style.opacity = '';
    elem.style.display = display;
  };
  var hide = function hide(elem) {
    elem.style.opacity = '';
    elem.style.display = 'none';
  };
  var toggle = function toggle(elem, condition, display) {
    condition ? show(elem, display) : hide(elem);
  }; // borrowed from jquery $(elem).is(':visible') implementation

  var isVisible = function isVisible(elem) {
    return !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
  };
  /* istanbul ignore next */

  var isScrollable = function isScrollable(elem) {
    return !!(elem.scrollHeight > elem.clientHeight);
  }; // borrowed from https://stackoverflow.com/a/46352119

  var hasCssAnimation = function hasCssAnimation(elem) {
    var style = window.getComputedStyle(elem);
    var animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
    var transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
    return animDuration > 0 || transDuration > 0;
  };
  var contains = function contains(haystack, needle) {
    if (typeof haystack.contains === 'function') {
      return haystack.contains(needle);
    }
  };
  var animateTimerProgressBar = function animateTimerProgressBar(timer) {
    var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var timerProgressBar = getTimerProgressBar();

    if (isVisible(timerProgressBar)) {
      if (reset) {
        timerProgressBar.style.transition = 'none';
        timerProgressBar.style.width = '100%';
      }

      setTimeout(function () {
        timerProgressBar.style.transition = "width ".concat(timer / 1000, "s linear");
        timerProgressBar.style.width = '0%';
      }, 10);
    }
  };
  var stopTimerProgressBar = function stopTimerProgressBar() {
    var timerProgressBar = getTimerProgressBar();
    var timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
    timerProgressBar.style.removeProperty('transition');
    timerProgressBar.style.width = '100%';
    var timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
    var timerProgressBarPercent = parseInt(timerProgressBarWidth / timerProgressBarFullWidth * 100);
    timerProgressBar.style.removeProperty('transition');
    timerProgressBar.style.width = "".concat(timerProgressBarPercent, "%");
  };

  // Detect Node env
  var isNodeEnv = function isNodeEnv() {
    return typeof window === 'undefined' || typeof document === 'undefined';
  };

  var sweetHTML = "\n <div aria-labelledby=\"".concat(swalClasses.title, "\" aria-describedby=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses.popup, "\" tabindex=\"-1\">\n   <div class=\"").concat(swalClasses.header, "\">\n     <ul class=\"").concat(swalClasses['progress-steps'], "\"></ul>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.error, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.question, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.warning, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.info, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.success, "\"></div>\n     <img class=\"").concat(swalClasses.image, "\" />\n     <h2 class=\"").concat(swalClasses.title, "\" id=\"").concat(swalClasses.title, "\"></h2>\n     <button type=\"button\" class=\"").concat(swalClasses.close, "\"></button>\n   </div>\n   <div class=\"").concat(swalClasses.content, "\">\n     <div id=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses['html-container'], "\"></div>\n     <input class=\"").concat(swalClasses.input, "\" />\n     <input type=\"file\" class=\"").concat(swalClasses.file, "\" />\n     <div class=\"").concat(swalClasses.range, "\">\n       <input type=\"range\" />\n       <output></output>\n     </div>\n     <select class=\"").concat(swalClasses.select, "\"></select>\n     <div class=\"").concat(swalClasses.radio, "\"></div>\n     <label for=\"").concat(swalClasses.checkbox, "\" class=\"").concat(swalClasses.checkbox, "\">\n       <input type=\"checkbox\" />\n       <span class=\"").concat(swalClasses.label, "\"></span>\n     </label>\n     <textarea class=\"").concat(swalClasses.textarea, "\"></textarea>\n     <div class=\"").concat(swalClasses['validation-message'], "\" id=\"").concat(swalClasses['validation-message'], "\"></div>\n   </div>\n   <div class=\"").concat(swalClasses.actions, "\">\n     <button type=\"button\" class=\"").concat(swalClasses.confirm, "\">OK</button>\n     <button type=\"button\" class=\"").concat(swalClasses.cancel, "\">Cancel</button>\n   </div>\n   <div class=\"").concat(swalClasses.footer, "\"></div>\n   <div class=\"").concat(swalClasses['timer-progress-bar-container'], "\">\n     <div class=\"").concat(swalClasses['timer-progress-bar'], "\"></div>\n   </div>\n </div>\n").replace(/(^|\n)\s*/g, '');

  var resetOldContainer = function resetOldContainer() {
    var oldContainer = getContainer();

    if (!oldContainer) {
      return false;
    }

    oldContainer.parentNode.removeChild(oldContainer);
    removeClass([document.documentElement, document.body], [swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['has-column']]);
    return true;
  };

  var oldInputVal; // IE11 workaround, see #1109 for details

  var resetValidationMessage = function resetValidationMessage(e) {
    if (Swal.isVisible() && oldInputVal !== e.target.value) {
      Swal.resetValidationMessage();
    }

    oldInputVal = e.target.value;
  };

  var addInputChangeListeners = function addInputChangeListeners() {
    var content = getContent();
    var input = getChildByClass(content, swalClasses.input);
    var file = getChildByClass(content, swalClasses.file);
    var range = content.querySelector(".".concat(swalClasses.range, " input"));
    var rangeOutput = content.querySelector(".".concat(swalClasses.range, " output"));
    var select = getChildByClass(content, swalClasses.select);
    var checkbox = content.querySelector(".".concat(swalClasses.checkbox, " input"));
    var textarea = getChildByClass(content, swalClasses.textarea);
    input.oninput = resetValidationMessage;
    file.onchange = resetValidationMessage;
    select.onchange = resetValidationMessage;
    checkbox.onchange = resetValidationMessage;
    textarea.oninput = resetValidationMessage;

    range.oninput = function (e) {
      resetValidationMessage(e);
      rangeOutput.value = range.value;
    };

    range.onchange = function (e) {
      resetValidationMessage(e);
      range.nextSibling.value = range.value;
    };
  };

  var getTarget = function getTarget(target) {
    return typeof target === 'string' ? document.querySelector(target) : target;
  };

  var setupAccessibility = function setupAccessibility(params) {
    var popup = getPopup();
    popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
    popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');

    if (!params.toast) {
      popup.setAttribute('aria-modal', 'true');
    }
  };

  var setupRTL = function setupRTL(targetElement) {
    if (window.getComputedStyle(targetElement).direction === 'rtl') {
      addClass(getContainer(), swalClasses.rtl);
    }
  };
  /*
   * Add modal + backdrop to DOM
   */


  var init = function init(params) {
    // Clean up the old popup container if it exists
    var oldContainerExisted = resetOldContainer();
    /* istanbul ignore if */

    if (isNodeEnv()) {
      error('SweetAlert2 requires document to initialize');
      return;
    }

    var container = document.createElement('div');
    container.className = swalClasses.container;

    if (oldContainerExisted) {
      addClass(container, swalClasses['no-transition']);
    }

    setInnerHtml(container, sweetHTML);
    var targetElement = getTarget(params.target);
    targetElement.appendChild(container);
    setupAccessibility(params);
    setupRTL(targetElement);
    addInputChangeListeners();
  };

  var parseHtmlToContainer = function parseHtmlToContainer(param, target) {
    // DOM element
    if (param instanceof HTMLElement) {
      target.appendChild(param); // Object
    } else if (_typeof(param) === 'object') {
      handleObject(param, target); // Plain string
    } else if (param) {
      setInnerHtml(target, param);
    }
  };

  var handleObject = function handleObject(param, target) {
    // JQuery element(s)
    if (param.jquery) {
      handleJqueryElem(target, param); // For other objects use their string representation
    } else {
      setInnerHtml(target, param.toString());
    }
  };

  var handleJqueryElem = function handleJqueryElem(target, elem) {
    target.textContent = '';

    if (0 in elem) {
      for (var i = 0; (i in elem); i++) {
        target.appendChild(elem[i].cloneNode(true));
      }
    } else {
      target.appendChild(elem.cloneNode(true));
    }
  };

  var animationEndEvent = function () {
    // Prevent run in Node env

    /* istanbul ignore if */
    if (isNodeEnv()) {
      return false;
    }

    var testEl = document.createElement('div');
    var transEndEventNames = {
      WebkitAnimation: 'webkitAnimationEnd',
      OAnimation: 'oAnimationEnd oanimationend',
      animation: 'animationend'
    };

    for (var i in transEndEventNames) {
      if (Object.prototype.hasOwnProperty.call(transEndEventNames, i) && typeof testEl.style[i] !== 'undefined') {
        return transEndEventNames[i];
      }
    }

    return false;
  }();

  // https://github.com/twbs/bootstrap/blob/master/js/src/modal.js

  var measureScrollbar = function measureScrollbar() {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = swalClasses['scrollbar-measure'];
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  };

  var renderActions = function renderActions(instance, params) {
    var actions = getActions();
    var confirmButton = getConfirmButton();
    var cancelButton = getCancelButton(); // Actions (buttons) wrapper

    if (!params.showConfirmButton && !params.showCancelButton) {
      hide(actions);
    } // Custom class


    applyCustomClass(actions, params, 'actions'); // Render confirm button

    renderButton(confirmButton, 'confirm', params); // render Cancel Button

    renderButton(cancelButton, 'cancel', params);

    if (params.buttonsStyling) {
      handleButtonsStyling(confirmButton, cancelButton, params);
    } else {
      removeClass([confirmButton, cancelButton], swalClasses.styled);
      confirmButton.style.backgroundColor = confirmButton.style.borderLeftColor = confirmButton.style.borderRightColor = '';
      cancelButton.style.backgroundColor = cancelButton.style.borderLeftColor = cancelButton.style.borderRightColor = '';
    }

    if (params.reverseButtons) {
      confirmButton.parentNode.insertBefore(cancelButton, confirmButton);
    }
  };

  function handleButtonsStyling(confirmButton, cancelButton, params) {
    addClass([confirmButton, cancelButton], swalClasses.styled); // Buttons background colors

    if (params.confirmButtonColor) {
      confirmButton.style.backgroundColor = params.confirmButtonColor;
    }

    if (params.cancelButtonColor) {
      cancelButton.style.backgroundColor = params.cancelButtonColor;
    } // Loading state


    if (!isLoading()) {
      var confirmButtonBackgroundColor = window.getComputedStyle(confirmButton).getPropertyValue('background-color');
      confirmButton.style.borderLeftColor = confirmButtonBackgroundColor;
      confirmButton.style.borderRightColor = confirmButtonBackgroundColor;
    }
  }

  function renderButton(button, buttonType, params) {
    toggle(button, params["show".concat(capitalizeFirstLetter(buttonType), "Button")], 'inline-block');
    setInnerHtml(button, params["".concat(buttonType, "ButtonText")]); // Set caption text

    button.setAttribute('aria-label', params["".concat(buttonType, "ButtonAriaLabel")]); // ARIA label
    // Add buttons custom classes

    button.className = swalClasses[buttonType];
    applyCustomClass(button, params, "".concat(buttonType, "Button"));
    addClass(button, params["".concat(buttonType, "ButtonClass")]);
  }

  function handleBackdropParam(container, backdrop) {
    if (typeof backdrop === 'string') {
      container.style.background = backdrop;
    } else if (!backdrop) {
      addClass([document.documentElement, document.body], swalClasses['no-backdrop']);
    }
  }

  function handlePositionParam(container, position) {
    if (position in swalClasses) {
      addClass(container, swalClasses[position]);
    } else {
      warn('The "position" parameter is not valid, defaulting to "center"');
      addClass(container, swalClasses.center);
    }
  }

  function handleGrowParam(container, grow) {
    if (grow && typeof grow === 'string') {
      var growClass = "grow-".concat(grow);

      if (growClass in swalClasses) {
        addClass(container, swalClasses[growClass]);
      }
    }
  }

  var renderContainer = function renderContainer(instance, params) {
    var container = getContainer();

    if (!container) {
      return;
    }

    handleBackdropParam(container, params.backdrop);

    if (!params.backdrop && params.allowOutsideClick) {
      warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
    }

    handlePositionParam(container, params.position);
    handleGrowParam(container, params.grow); // Custom class

    applyCustomClass(container, params, 'container'); // Set queue step attribute for getQueueStep() method

    var queueStep = document.body.getAttribute('data-swal2-queue-step');

    if (queueStep) {
      container.setAttribute('data-queue-step', queueStep);
      document.body.removeAttribute('data-swal2-queue-step');
    }
  };

  /**
   * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */
  var privateProps = {
    promise: new WeakMap(),
    innerParams: new WeakMap(),
    domCache: new WeakMap()
  };

  var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
  var renderInput = function renderInput(instance, params) {
    var content = getContent();
    var innerParams = privateProps.innerParams.get(instance);
    var rerender = !innerParams || params.input !== innerParams.input;
    inputTypes.forEach(function (inputType) {
      var inputClass = swalClasses[inputType];
      var inputContainer = getChildByClass(content, inputClass); // set attributes

      setAttributes(inputType, params.inputAttributes); // set class

      inputContainer.className = inputClass;

      if (rerender) {
        hide(inputContainer);
      }
    });

    if (params.input) {
      if (rerender) {
        showInput(params);
      } // set custom class


      setCustomClass(params);
    }
  };

  var showInput = function showInput(params) {
    if (!renderInputType[params.input]) {
      return error("Unexpected type of input! Expected \"text\", \"email\", \"password\", \"number\", \"tel\", \"select\", \"radio\", \"checkbox\", \"textarea\", \"file\" or \"url\", got \"".concat(params.input, "\""));
    }

    var inputContainer = getInputContainer(params.input);
    var input = renderInputType[params.input](inputContainer, params);
    show(input); // input autofocus

    setTimeout(function () {
      focusInput(input);
    });
  };

  var removeAttributes = function removeAttributes(input) {
    for (var i = 0; i < input.attributes.length; i++) {
      var attrName = input.attributes[i].name;

      if (!(['type', 'value', 'style'].indexOf(attrName) !== -1)) {
        input.removeAttribute(attrName);
      }
    }
  };

  var setAttributes = function setAttributes(inputType, inputAttributes) {
    var input = getInput(getContent(), inputType);

    if (!input) {
      return;
    }

    removeAttributes(input);

    for (var attr in inputAttributes) {
      // Do not set a placeholder for <input type="range">
      // it'll crash Edge, #1298
      if (inputType === 'range' && attr === 'placeholder') {
        continue;
      }

      input.setAttribute(attr, inputAttributes[attr]);
    }
  };

  var setCustomClass = function setCustomClass(params) {
    var inputContainer = getInputContainer(params.input);

    if (params.customClass) {
      addClass(inputContainer, params.customClass.input);
    }
  };

  var setInputPlaceholder = function setInputPlaceholder(input, params) {
    if (!input.placeholder || params.inputPlaceholder) {
      input.placeholder = params.inputPlaceholder;
    }
  };

  var getInputContainer = function getInputContainer(inputType) {
    var inputClass = swalClasses[inputType] ? swalClasses[inputType] : swalClasses.input;
    return getChildByClass(getContent(), inputClass);
  };

  var renderInputType = {};

  renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = function (input, params) {
    if (typeof params.inputValue === 'string' || typeof params.inputValue === 'number') {
      input.value = params.inputValue;
    } else if (!isPromise(params.inputValue)) {
      warn("Unexpected type of inputValue! Expected \"string\", \"number\" or \"Promise\", got \"".concat(_typeof(params.inputValue), "\""));
    }

    setInputPlaceholder(input, params);
    input.type = params.input;
    return input;
  };

  renderInputType.file = function (input, params) {
    setInputPlaceholder(input, params);
    return input;
  };

  renderInputType.range = function (range, params) {
    var rangeInput = range.querySelector('input');
    var rangeOutput = range.querySelector('output');
    rangeInput.value = params.inputValue;
    rangeInput.type = params.input;
    rangeOutput.value = params.inputValue;
    return range;
  };

  renderInputType.select = function (select, params) {
    select.textContent = '';

    if (params.inputPlaceholder) {
      var placeholder = document.createElement('option');
      setInnerHtml(placeholder, params.inputPlaceholder);
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      select.appendChild(placeholder);
    }

    return select;
  };

  renderInputType.radio = function (radio) {
    radio.textContent = '';
    return radio;
  };

  renderInputType.checkbox = function (checkboxContainer, params) {
    var checkbox = getInput(getContent(), 'checkbox');
    checkbox.value = 1;
    checkbox.id = swalClasses.checkbox;
    checkbox.checked = Boolean(params.inputValue);
    var label = checkboxContainer.querySelector('span');
    setInnerHtml(label, params.inputPlaceholder);
    return checkboxContainer;
  };

  renderInputType.textarea = function (textarea, params) {
    textarea.value = params.inputValue;
    setInputPlaceholder(textarea, params);

    if ('MutationObserver' in window) {
      // #1699
      var initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
      var popupPadding = parseInt(window.getComputedStyle(getPopup()).paddingLeft) + parseInt(window.getComputedStyle(getPopup()).paddingRight);

      var outputsize = function outputsize() {
        var contentWidth = textarea.offsetWidth + popupPadding;

        if (contentWidth > initialPopupWidth) {
          getPopup().style.width = "".concat(contentWidth, "px");
        } else {
          getPopup().style.width = null;
        }
      };

      new MutationObserver(outputsize).observe(textarea, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    return textarea;
  };

  var renderContent = function renderContent(instance, params) {
    var content = getContent().querySelector("#".concat(swalClasses.content)); // Content as HTML

    if (params.html) {
      parseHtmlToContainer(params.html, content);
      show(content, 'block'); // Content as plain text
    } else if (params.text) {
      content.textContent = params.text;
      show(content, 'block'); // No content
    } else {
      hide(content);
    }

    renderInput(instance, params); // Custom class

    applyCustomClass(getContent(), params, 'content');
  };

  var renderFooter = function renderFooter(instance, params) {
    var footer = getFooter();
    toggle(footer, params.footer);

    if (params.footer) {
      parseHtmlToContainer(params.footer, footer);
    } // Custom class


    applyCustomClass(footer, params, 'footer');
  };

  var renderCloseButton = function renderCloseButton(instance, params) {
    var closeButton = getCloseButton();
    setInnerHtml(closeButton, params.closeButtonHtml); // Custom class

    applyCustomClass(closeButton, params, 'closeButton');
    toggle(closeButton, params.showCloseButton);
    closeButton.setAttribute('aria-label', params.closeButtonAriaLabel);
  };

  var renderIcon = function renderIcon(instance, params) {
    var innerParams = privateProps.innerParams.get(instance); // if the give icon already rendered, apply the custom class without re-rendering the icon

    if (innerParams && params.icon === innerParams.icon && getIcon()) {
      applyCustomClass(getIcon(), params, 'icon');
      return;
    }

    hideAllIcons();

    if (!params.icon) {
      return;
    }

    if (Object.keys(iconTypes).indexOf(params.icon) !== -1) {
      var icon = elementBySelector(".".concat(swalClasses.icon, ".").concat(iconTypes[params.icon]));
      show(icon); // Custom or default content

      setContent(icon, params);
      adjustSuccessIconBackgoundColor(); // Custom class

      applyCustomClass(icon, params, 'icon'); // Animate icon

      addClass(icon, params.showClass.icon);
    } else {
      error("Unknown icon! Expected \"success\", \"error\", \"warning\", \"info\" or \"question\", got \"".concat(params.icon, "\""));
    }
  };

  var hideAllIcons = function hideAllIcons() {
    var icons = getIcons();

    for (var i = 0; i < icons.length; i++) {
      hide(icons[i]);
    }
  }; // Adjust success icon background color to match the popup background color


  var adjustSuccessIconBackgoundColor = function adjustSuccessIconBackgoundColor() {
    var popup = getPopup();
    var popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
    var successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');

    for (var i = 0; i < successIconParts.length; i++) {
      successIconParts[i].style.backgroundColor = popupBackgroundColor;
    }
  };

  var setContent = function setContent(icon, params) {
    icon.textContent = '';

    if (params.iconHtml) {
      setInnerHtml(icon, iconContent(params.iconHtml));
    } else if (params.icon === 'success') {
      setInnerHtml(icon, "\n      <div class=\"swal2-success-circular-line-left\"></div>\n      <span class=\"swal2-success-line-tip\"></span> <span class=\"swal2-success-line-long\"></span>\n      <div class=\"swal2-success-ring\"></div> <div class=\"swal2-success-fix\"></div>\n      <div class=\"swal2-success-circular-line-right\"></div>\n    ");
    } else if (params.icon === 'error') {
      setInnerHtml(icon, "\n      <span class=\"swal2-x-mark\">\n        <span class=\"swal2-x-mark-line-left\"></span>\n        <span class=\"swal2-x-mark-line-right\"></span>\n      </span>\n    ");
    } else {
      var defaultIconHtml = {
        question: '?',
        warning: '!',
        info: 'i'
      };
      setInnerHtml(icon, iconContent(defaultIconHtml[params.icon]));
    }
  };

  var iconContent = function iconContent(content) {
    return "<div class=\"".concat(swalClasses['icon-content'], "\">").concat(content, "</div>");
  };

  var renderImage = function renderImage(instance, params) {
    var image = getImage();

    if (!params.imageUrl) {
      return hide(image);
    }

    show(image, ''); // Src, alt

    image.setAttribute('src', params.imageUrl);
    image.setAttribute('alt', params.imageAlt); // Width, height

    applyNumericalStyle(image, 'width', params.imageWidth);
    applyNumericalStyle(image, 'height', params.imageHeight); // Class

    image.className = swalClasses.image;
    applyCustomClass(image, params, 'image');
  };

  var currentSteps = [];
  /*
   * Global function for chaining sweetAlert popups
   */

  var queue = function queue(steps) {
    var Swal = this;
    currentSteps = steps;

    var resetAndResolve = function resetAndResolve(resolve, value) {
      currentSteps = [];
      resolve(value);
    };

    var queueResult = [];
    return new Promise(function (resolve) {
      (function step(i, callback) {
        if (i < currentSteps.length) {
          document.body.setAttribute('data-swal2-queue-step', i);
          Swal.fire(currentSteps[i]).then(function (result) {
            if (typeof result.value !== 'undefined') {
              queueResult.push(result.value);
              step(i + 1, callback);
            } else {
              resetAndResolve(resolve, {
                dismiss: result.dismiss
              });
            }
          });
        } else {
          resetAndResolve(resolve, {
            value: queueResult
          });
        }
      })(0);
    });
  };
  /*
   * Global function for getting the index of current popup in queue
   */

  var getQueueStep = function getQueueStep() {
    return getContainer() && getContainer().getAttribute('data-queue-step');
  };
  /*
   * Global function for inserting a popup to the queue
   */

  var insertQueueStep = function insertQueueStep(step, index) {
    if (index && index < currentSteps.length) {
      return currentSteps.splice(index, 0, step);
    }

    return currentSteps.push(step);
  };
  /*
   * Global function for deleting a popup from the queue
   */

  var deleteQueueStep = function deleteQueueStep(index) {
    if (typeof currentSteps[index] !== 'undefined') {
      currentSteps.splice(index, 1);
    }
  };

  var createStepElement = function createStepElement(step) {
    var stepEl = document.createElement('li');
    addClass(stepEl, swalClasses['progress-step']);
    setInnerHtml(stepEl, step);
    return stepEl;
  };

  var createLineElement = function createLineElement(params) {
    var lineEl = document.createElement('li');
    addClass(lineEl, swalClasses['progress-step-line']);

    if (params.progressStepsDistance) {
      lineEl.style.width = params.progressStepsDistance;
    }

    return lineEl;
  };

  var renderProgressSteps = function renderProgressSteps(instance, params) {
    var progressStepsContainer = getProgressSteps();

    if (!params.progressSteps || params.progressSteps.length === 0) {
      return hide(progressStepsContainer);
    }

    show(progressStepsContainer);
    progressStepsContainer.textContent = '';
    var currentProgressStep = parseInt(params.currentProgressStep === undefined ? getQueueStep() : params.currentProgressStep);

    if (currentProgressStep >= params.progressSteps.length) {
      warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
    }

    params.progressSteps.forEach(function (step, index) {
      var stepEl = createStepElement(step);
      progressStepsContainer.appendChild(stepEl);

      if (index === currentProgressStep) {
        addClass(stepEl, swalClasses['active-progress-step']);
      }

      if (index !== params.progressSteps.length - 1) {
        var lineEl = createLineElement(params);
        progressStepsContainer.appendChild(lineEl);
      }
    });
  };

  var renderTitle = function renderTitle(instance, params) {
    var title = getTitle();
    toggle(title, params.title || params.titleText);

    if (params.title) {
      parseHtmlToContainer(params.title, title);
    }

    if (params.titleText) {
      title.innerText = params.titleText;
    } // Custom class


    applyCustomClass(title, params, 'title');
  };

  var renderHeader = function renderHeader(instance, params) {
    var header = getHeader(); // Custom class

    applyCustomClass(header, params, 'header'); // Progress steps

    renderProgressSteps(instance, params); // Icon

    renderIcon(instance, params); // Image

    renderImage(instance, params); // Title

    renderTitle(instance, params); // Close button

    renderCloseButton(instance, params);
  };

  var renderPopup = function renderPopup(instance, params) {
    var popup = getPopup(); // Width

    applyNumericalStyle(popup, 'width', params.width); // Padding

    applyNumericalStyle(popup, 'padding', params.padding); // Background

    if (params.background) {
      popup.style.background = params.background;
    } // Classes


    addClasses(popup, params);
  };

  var addClasses = function addClasses(popup, params) {
    // Default Class + showClass when updating Swal.update({})
    popup.className = "".concat(swalClasses.popup, " ").concat(isVisible(popup) ? params.showClass.popup : '');

    if (params.toast) {
      addClass([document.documentElement, document.body], swalClasses['toast-shown']);
      addClass(popup, swalClasses.toast);
    } else {
      addClass(popup, swalClasses.modal);
    } // Custom class


    applyCustomClass(popup, params, 'popup');

    if (typeof params.customClass === 'string') {
      addClass(popup, params.customClass);
    } // Icon class (#1842)


    if (params.icon) {
      addClass(popup, swalClasses["icon-".concat(params.icon)]);
    }
  };

  var render = function render(instance, params) {
    renderPopup(instance, params);
    renderContainer(instance, params);
    renderHeader(instance, params);
    renderContent(instance, params);
    renderActions(instance, params);
    renderFooter(instance, params);

    if (typeof params.onRender === 'function') {
      params.onRender(getPopup());
    }
  };

  /*
   * Global function to determine if SweetAlert2 popup is shown
   */

  var isVisible$1 = function isVisible$$1() {
    return isVisible(getPopup());
  };
  /*
   * Global function to click 'Confirm' button
   */

  var clickConfirm = function clickConfirm() {
    return getConfirmButton() && getConfirmButton().click();
  };
  /*
   * Global function to click 'Cancel' button
   */

  var clickCancel = function clickCancel() {
    return getCancelButton() && getCancelButton().click();
  };

  function fire() {
    var Swal = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _construct(Swal, args);
  }

  /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param mixinParams
   */
  function mixin(mixinParams) {
    var MixinSwal = /*#__PURE__*/function (_this) {
      _inherits(MixinSwal, _this);

      var _super = _createSuper(MixinSwal);

      function MixinSwal() {
        _classCallCheck(this, MixinSwal);

        return _super.apply(this, arguments);
      }

      _createClass(MixinSwal, [{
        key: "_main",
        value: function _main(params) {
          return _get(_getPrototypeOf(MixinSwal.prototype), "_main", this).call(this, _extends({}, mixinParams, params));
        }
      }]);

      return MixinSwal;
    }(this);

    return MixinSwal;
  }

  /**
   * Show spinner instead of Confirm button
   */

  var showLoading = function showLoading() {
    var popup = getPopup();

    if (!popup) {
      Swal.fire();
    }

    popup = getPopup();
    var actions = getActions();
    var confirmButton = getConfirmButton();
    show(actions);
    show(confirmButton, 'inline-block');
    addClass([popup, actions], swalClasses.loading);
    confirmButton.disabled = true;
    popup.setAttribute('data-loading', true);
    popup.setAttribute('aria-busy', true);
    popup.focus();
  };

  var RESTORE_FOCUS_TIMEOUT = 100;

  var globalState = {};

  var focusPreviousActiveElement = function focusPreviousActiveElement() {
    if (globalState.previousActiveElement && globalState.previousActiveElement.focus) {
      globalState.previousActiveElement.focus();
      globalState.previousActiveElement = null;
    } else if (document.body) {
      document.body.focus();
    }
  }; // Restore previous active (focused) element


  var restoreActiveElement = function restoreActiveElement() {
    return new Promise(function (resolve) {
      var x = window.scrollX;
      var y = window.scrollY;
      globalState.restoreFocusTimeout = setTimeout(function () {
        focusPreviousActiveElement();
        resolve();
      }, RESTORE_FOCUS_TIMEOUT); // issues/900

      /* istanbul ignore if */

      if (typeof x !== 'undefined' && typeof y !== 'undefined') {
        // IE doesn't have scrollX/scrollY support
        window.scrollTo(x, y);
      }
    });
  };

  /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   */

  var getTimerLeft = function getTimerLeft() {
    return globalState.timeout && globalState.timeout.getTimerLeft();
  };
  /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var stopTimer = function stopTimer() {
    if (globalState.timeout) {
      stopTimerProgressBar();
      return globalState.timeout.stop();
    }
  };
  /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var resumeTimer = function resumeTimer() {
    if (globalState.timeout) {
      var remaining = globalState.timeout.start();
      animateTimerProgressBar(remaining);
      return remaining;
    }
  };
  /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   */

  var toggleTimer = function toggleTimer() {
    var timer = globalState.timeout;
    return timer && (timer.running ? stopTimer() : resumeTimer());
  };
  /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   */

  var increaseTimer = function increaseTimer(n) {
    if (globalState.timeout) {
      var remaining = globalState.timeout.increase(n);
      animateTimerProgressBar(remaining, true);
      return remaining;
    }
  };
  /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   */

  var isTimerRunning = function isTimerRunning() {
    return globalState.timeout && globalState.timeout.isRunning();
  };

  var defaultParams = {
    title: '',
    titleText: '',
    text: '',
    html: '',
    footer: '',
    icon: undefined,
    iconHtml: undefined,
    toast: false,
    animation: true,
    showClass: {
      popup: 'swal2-show',
      backdrop: 'swal2-backdrop-show',
      icon: 'swal2-icon-show'
    },
    hideClass: {
      popup: 'swal2-hide',
      backdrop: 'swal2-backdrop-hide',
      icon: 'swal2-icon-hide'
    },
    customClass: undefined,
    target: 'body',
    backdrop: true,
    heightAuto: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    allowEnterKey: true,
    stopKeydownPropagation: true,
    keydownListenerCapture: false,
    showConfirmButton: true,
    showCancelButton: false,
    preConfirm: undefined,
    confirmButtonText: 'OK',
    confirmButtonAriaLabel: '',
    confirmButtonColor: undefined,
    cancelButtonText: 'Cancel',
    cancelButtonAriaLabel: '',
    cancelButtonColor: undefined,
    buttonsStyling: true,
    reverseButtons: false,
    focusConfirm: true,
    focusCancel: false,
    showCloseButton: false,
    closeButtonHtml: '&times;',
    closeButtonAriaLabel: 'Close this dialog',
    showLoaderOnConfirm: false,
    imageUrl: undefined,
    imageWidth: undefined,
    imageHeight: undefined,
    imageAlt: '',
    timer: undefined,
    timerProgressBar: false,
    width: undefined,
    padding: undefined,
    background: undefined,
    input: undefined,
    inputPlaceholder: '',
    inputValue: '',
    inputOptions: {},
    inputAutoTrim: true,
    inputAttributes: {},
    inputValidator: undefined,
    validationMessage: undefined,
    grow: false,
    position: 'center',
    progressSteps: [],
    currentProgressStep: undefined,
    progressStepsDistance: undefined,
    onBeforeOpen: undefined,
    onOpen: undefined,
    onRender: undefined,
    onClose: undefined,
    onAfterClose: undefined,
    onDestroy: undefined,
    scrollbarPadding: true
  };
  var updatableParams = ['allowEscapeKey', 'allowOutsideClick', 'buttonsStyling', 'cancelButtonAriaLabel', 'cancelButtonColor', 'cancelButtonText', 'closeButtonAriaLabel', 'closeButtonHtml', 'confirmButtonAriaLabel', 'confirmButtonColor', 'confirmButtonText', 'currentProgressStep', 'customClass', 'footer', 'hideClass', 'html', 'icon', 'imageAlt', 'imageHeight', 'imageUrl', 'imageWidth', 'onAfterClose', 'onClose', 'onDestroy', 'progressSteps', 'reverseButtons', 'showCancelButton', 'showCloseButton', 'showConfirmButton', 'text', 'title', 'titleText'];
  var deprecatedParams = {
    animation: 'showClass" and "hideClass'
  };
  var toastIncompatibleParams = ['allowOutsideClick', 'allowEnterKey', 'backdrop', 'focusConfirm', 'focusCancel', 'heightAuto', 'keydownListenerCapture'];
  /**
   * Is valid parameter
   * @param {String} paramName
   */

  var isValidParameter = function isValidParameter(paramName) {
    return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
  };
  /**
   * Is valid parameter for Swal.update() method
   * @param {String} paramName
   */

  var isUpdatableParameter = function isUpdatableParameter(paramName) {
    return updatableParams.indexOf(paramName) !== -1;
  };
  /**
   * Is deprecated parameter
   * @param {String} paramName
   */

  var isDeprecatedParameter = function isDeprecatedParameter(paramName) {
    return deprecatedParams[paramName];
  };

  var checkIfParamIsValid = function checkIfParamIsValid(param) {
    if (!isValidParameter(param)) {
      warn("Unknown parameter \"".concat(param, "\""));
    }
  };

  var checkIfToastParamIsValid = function checkIfToastParamIsValid(param) {
    if (toastIncompatibleParams.indexOf(param) !== -1) {
      warn("The parameter \"".concat(param, "\" is incompatible with toasts"));
    }
  };

  var checkIfParamIsDeprecated = function checkIfParamIsDeprecated(param) {
    if (isDeprecatedParameter(param)) {
      warnAboutDepreation(param, isDeprecatedParameter(param));
    }
  };
  /**
   * Show relevant warnings for given params
   *
   * @param params
   */


  var showWarningsForParams = function showWarningsForParams(params) {
    for (var param in params) {
      checkIfParamIsValid(param);

      if (params.toast) {
        checkIfToastParamIsValid(param);
      }

      checkIfParamIsDeprecated(param);
    }
  };



  var staticMethods = /*#__PURE__*/Object.freeze({
    isValidParameter: isValidParameter,
    isUpdatableParameter: isUpdatableParameter,
    isDeprecatedParameter: isDeprecatedParameter,
    argsToParams: argsToParams,
    isVisible: isVisible$1,
    clickConfirm: clickConfirm,
    clickCancel: clickCancel,
    getContainer: getContainer,
    getPopup: getPopup,
    getTitle: getTitle,
    getContent: getContent,
    getHtmlContainer: getHtmlContainer,
    getImage: getImage,
    getIcon: getIcon,
    getIcons: getIcons,
    getCloseButton: getCloseButton,
    getActions: getActions,
    getConfirmButton: getConfirmButton,
    getCancelButton: getCancelButton,
    getHeader: getHeader,
    getFooter: getFooter,
    getTimerProgressBar: getTimerProgressBar,
    getFocusableElements: getFocusableElements,
    getValidationMessage: getValidationMessage,
    isLoading: isLoading,
    fire: fire,
    mixin: mixin,
    queue: queue,
    getQueueStep: getQueueStep,
    insertQueueStep: insertQueueStep,
    deleteQueueStep: deleteQueueStep,
    showLoading: showLoading,
    enableLoading: showLoading,
    getTimerLeft: getTimerLeft,
    stopTimer: stopTimer,
    resumeTimer: resumeTimer,
    toggleTimer: toggleTimer,
    increaseTimer: increaseTimer,
    isTimerRunning: isTimerRunning
  });

  /**
   * Enables buttons and hide loader.
   */

  function hideLoading() {
    // do nothing if popup is closed
    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams) {
      return;
    }

    var domCache = privateProps.domCache.get(this);

    if (!innerParams.showConfirmButton) {
      hide(domCache.confirmButton);

      if (!innerParams.showCancelButton) {
        hide(domCache.actions);
      }
    }

    removeClass([domCache.popup, domCache.actions], swalClasses.loading);
    domCache.popup.removeAttribute('aria-busy');
    domCache.popup.removeAttribute('data-loading');
    domCache.confirmButton.disabled = false;
    domCache.cancelButton.disabled = false;
  }

  function getInput$1(instance) {
    var innerParams = privateProps.innerParams.get(instance || this);
    var domCache = privateProps.domCache.get(instance || this);

    if (!domCache) {
      return null;
    }

    return getInput(domCache.content, innerParams.input);
  }

  var fixScrollbar = function fixScrollbar() {
    // for queues, do not do this more than once
    if (states.previousBodyPadding !== null) {
      return;
    } // if the body has overflow


    if (document.body.scrollHeight > window.innerHeight) {
      // add padding so the content doesn't shift after removal of scrollbar
      states.previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
      document.body.style.paddingRight = "".concat(states.previousBodyPadding + measureScrollbar(), "px");
    }
  };
  var undoScrollbar = function undoScrollbar() {
    if (states.previousBodyPadding !== null) {
      document.body.style.paddingRight = "".concat(states.previousBodyPadding, "px");
      states.previousBodyPadding = null;
    }
  };

  /* istanbul ignore file */

  var iOSfix = function iOSfix() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
      var offset = document.body.scrollTop;
      document.body.style.top = "".concat(offset * -1, "px");
      addClass(document.body, swalClasses.iosfix);
      lockBodyScroll();
      addBottomPaddingForTallPopups(); // #1948
    }
  };

  var addBottomPaddingForTallPopups = function addBottomPaddingForTallPopups() {
    var safari = !navigator.userAgent.match(/(CriOS|FxiOS|EdgiOS|YaBrowser|UCBrowser)/i);

    if (safari) {
      var bottomPanelHeight = 44;

      if (getPopup().scrollHeight > window.innerHeight - bottomPanelHeight) {
        getContainer().style.paddingBottom = "".concat(bottomPanelHeight, "px");
      }
    }
  };

  var lockBodyScroll = function lockBodyScroll() {
    // #1246
    var container = getContainer();
    var preventTouchMove;

    container.ontouchstart = function (e) {
      preventTouchMove = shouldPreventTouchMove(e.target);
    };

    container.ontouchmove = function (e) {
      if (preventTouchMove) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
  };

  var shouldPreventTouchMove = function shouldPreventTouchMove(target) {
    var container = getContainer();

    if (target === container) {
      return true;
    }

    if (!isScrollable(container) && target.tagName !== 'INPUT' && // #1603
    !(isScrollable(getContent()) && // #1944
    getContent().contains(target))) {
      return true;
    }

    return false;
  };

  var undoIOSfix = function undoIOSfix() {
    if (hasClass(document.body, swalClasses.iosfix)) {
      var offset = parseInt(document.body.style.top, 10);
      removeClass(document.body, swalClasses.iosfix);
      document.body.style.top = '';
      document.body.scrollTop = offset * -1;
    }
  };

  /* istanbul ignore file */

  var isIE11 = function isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }; // Fix IE11 centering sweetalert2/issues/933


  var fixVerticalPositionIE = function fixVerticalPositionIE() {
    var container = getContainer();
    var popup = getPopup();
    container.style.removeProperty('align-items');

    if (popup.offsetTop < 0) {
      container.style.alignItems = 'flex-start';
    }
  };

  var IEfix = function IEfix() {
    if (typeof window !== 'undefined' && isIE11()) {
      fixVerticalPositionIE();
      window.addEventListener('resize', fixVerticalPositionIE);
    }
  };
  var undoIEfix = function undoIEfix() {
    if (typeof window !== 'undefined' && isIE11()) {
      window.removeEventListener('resize', fixVerticalPositionIE);
    }
  };

  // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
  // elements not within the active modal dialog will not be surfaced if a user opens a screen
  // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.

  var setAriaHidden = function setAriaHidden() {
    var bodyChildren = toArray(document.body.children);
    bodyChildren.forEach(function (el) {
      if (el === getContainer() || contains(el, getContainer())) {
        return;
      }

      if (el.hasAttribute('aria-hidden')) {
        el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden'));
      }

      el.setAttribute('aria-hidden', 'true');
    });
  };
  var unsetAriaHidden = function unsetAriaHidden() {
    var bodyChildren = toArray(document.body.children);
    bodyChildren.forEach(function (el) {
      if (el.hasAttribute('data-previous-aria-hidden')) {
        el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden'));
        el.removeAttribute('data-previous-aria-hidden');
      } else {
        el.removeAttribute('aria-hidden');
      }
    });
  };

  /**
   * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */
  var privateMethods = {
    swalPromiseResolve: new WeakMap()
  };

  /*
   * Instance method to close sweetAlert
   */

  function removePopupAndResetState(instance, container, isToast$$1, onAfterClose) {
    if (isToast$$1) {
      triggerOnAfterCloseAndDispose(instance, onAfterClose);
    } else {
      restoreActiveElement().then(function () {
        return triggerOnAfterCloseAndDispose(instance, onAfterClose);
      });
      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = false;
    }

    if (container.parentNode && !document.body.getAttribute('data-swal2-queue-step')) {
      container.parentNode.removeChild(container);
    }

    if (isModal()) {
      undoScrollbar();
      undoIOSfix();
      undoIEfix();
      unsetAriaHidden();
    }

    removeBodyClasses();
  }

  function removeBodyClasses() {
    removeClass([document.documentElement, document.body], [swalClasses.shown, swalClasses['height-auto'], swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['toast-column']]);
  }

  function close(resolveValue) {
    var popup = getPopup();

    if (!popup) {
      return;
    }

    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) {
      return;
    }

    var swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
    removeClass(popup, innerParams.showClass.popup);
    addClass(popup, innerParams.hideClass.popup);
    var backdrop = getContainer();
    removeClass(backdrop, innerParams.showClass.backdrop);
    addClass(backdrop, innerParams.hideClass.backdrop);
    handlePopupAnimation(this, popup, innerParams);

    if (typeof resolveValue !== 'undefined') {
      resolveValue.isDismissed = typeof resolveValue.dismiss !== 'undefined';
      resolveValue.isConfirmed = typeof resolveValue.dismiss === 'undefined';
    } else {
      resolveValue = {
        isDismissed: true,
        isConfirmed: false
      };
    } // Resolve Swal promise


    swalPromiseResolve(resolveValue || {});
  }

  var handlePopupAnimation = function handlePopupAnimation(instance, popup, innerParams) {
    var container = getContainer(); // If animation is supported, animate

    var animationIsSupported = animationEndEvent && hasCssAnimation(popup);
    var onClose = innerParams.onClose,
        onAfterClose = innerParams.onAfterClose;

    if (onClose !== null && typeof onClose === 'function') {
      onClose(popup);
    }

    if (animationIsSupported) {
      animatePopup(instance, popup, container, onAfterClose);
    } else {
      // Otherwise, remove immediately
      removePopupAndResetState(instance, container, isToast(), onAfterClose);
    }
  };

  var animatePopup = function animatePopup(instance, popup, container, onAfterClose) {
    globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, isToast(), onAfterClose);
    popup.addEventListener(animationEndEvent, function (e) {
      if (e.target === popup) {
        globalState.swalCloseEventFinishedCallback();
        delete globalState.swalCloseEventFinishedCallback;
      }
    });
  };

  var triggerOnAfterCloseAndDispose = function triggerOnAfterCloseAndDispose(instance, onAfterClose) {
    setTimeout(function () {
      if (typeof onAfterClose === 'function') {
        onAfterClose();
      }

      instance._destroy();
    });
  };

  function setButtonsDisabled(instance, buttons, disabled) {
    var domCache = privateProps.domCache.get(instance);
    buttons.forEach(function (button) {
      domCache[button].disabled = disabled;
    });
  }

  function setInputDisabled(input, disabled) {
    if (!input) {
      return false;
    }

    if (input.type === 'radio') {
      var radiosContainer = input.parentNode.parentNode;
      var radios = radiosContainer.querySelectorAll('input');

      for (var i = 0; i < radios.length; i++) {
        radios[i].disabled = disabled;
      }
    } else {
      input.disabled = disabled;
    }
  }

  function enableButtons() {
    setButtonsDisabled(this, ['confirmButton', 'cancelButton'], false);
  }
  function disableButtons() {
    setButtonsDisabled(this, ['confirmButton', 'cancelButton'], true);
  }
  function enableInput() {
    return setInputDisabled(this.getInput(), false);
  }
  function disableInput() {
    return setInputDisabled(this.getInput(), true);
  }

  function showValidationMessage(error) {
    var domCache = privateProps.domCache.get(this);
    setInnerHtml(domCache.validationMessage, error);
    var popupComputedStyle = window.getComputedStyle(domCache.popup);
    domCache.validationMessage.style.marginLeft = "-".concat(popupComputedStyle.getPropertyValue('padding-left'));
    domCache.validationMessage.style.marginRight = "-".concat(popupComputedStyle.getPropertyValue('padding-right'));
    show(domCache.validationMessage);
    var input = this.getInput();

    if (input) {
      input.setAttribute('aria-invalid', true);
      input.setAttribute('aria-describedBy', swalClasses['validation-message']);
      focusInput(input);
      addClass(input, swalClasses.inputerror);
    }
  } // Hide block with validation message

  function resetValidationMessage$1() {
    var domCache = privateProps.domCache.get(this);

    if (domCache.validationMessage) {
      hide(domCache.validationMessage);
    }

    var input = this.getInput();

    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedBy');
      removeClass(input, swalClasses.inputerror);
    }
  }

  function getProgressSteps$1() {
    var domCache = privateProps.domCache.get(this);
    return domCache.progressSteps;
  }

  var Timer = /*#__PURE__*/function () {
    function Timer(callback, delay) {
      _classCallCheck(this, Timer);

      this.callback = callback;
      this.remaining = delay;
      this.running = false;
      this.start();
    }

    _createClass(Timer, [{
      key: "start",
      value: function start() {
        if (!this.running) {
          this.running = true;
          this.started = new Date();
          this.id = setTimeout(this.callback, this.remaining);
        }

        return this.remaining;
      }
    }, {
      key: "stop",
      value: function stop() {
        if (this.running) {
          this.running = false;
          clearTimeout(this.id);
          this.remaining -= new Date() - this.started;
        }

        return this.remaining;
      }
    }, {
      key: "increase",
      value: function increase(n) {
        var running = this.running;

        if (running) {
          this.stop();
        }

        this.remaining += n;

        if (running) {
          this.start();
        }

        return this.remaining;
      }
    }, {
      key: "getTimerLeft",
      value: function getTimerLeft() {
        if (this.running) {
          this.stop();
          this.start();
        }

        return this.remaining;
      }
    }, {
      key: "isRunning",
      value: function isRunning() {
        return this.running;
      }
    }]);

    return Timer;
  }();

  var defaultInputValidators = {
    email: function email(string, validationMessage) {
      return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
    },
    url: function url(string, validationMessage) {
      // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
      return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
    }
  };

  function setDefaultInputValidators(params) {
    // Use default `inputValidator` for supported input types if not provided
    if (!params.inputValidator) {
      Object.keys(defaultInputValidators).forEach(function (key) {
        if (params.input === key) {
          params.inputValidator = defaultInputValidators[key];
        }
      });
    }
  }

  function validateCustomTargetElement(params) {
    // Determine if the custom target element is valid
    if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
      warn('Target parameter is not valid, defaulting to "body"');
      params.target = 'body';
    }
  }
  /**
   * Set type, text and actions on popup
   *
   * @param params
   * @returns {boolean}
   */


  function setParameters(params) {
    setDefaultInputValidators(params); // showLoaderOnConfirm && preConfirm

    if (params.showLoaderOnConfirm && !params.preConfirm) {
      warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://sweetalert2.github.io/#ajax-request');
    } // params.animation will be actually used in renderPopup.js
    // but in case when params.animation is a function, we need to call that function
    // before popup (re)initialization, so it'll be possible to check Swal.isVisible()
    // inside the params.animation function


    params.animation = callIfFunction(params.animation);
    validateCustomTargetElement(params); // Replace newlines with <br> in title

    if (typeof params.title === 'string') {
      params.title = params.title.split('\n').join('<br />');
    }

    init(params);
  }

  /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {Array} params
   */

  var openPopup = function openPopup(params) {
    var container = getContainer();
    var popup = getPopup();

    if (typeof params.onBeforeOpen === 'function') {
      params.onBeforeOpen(popup);
    }

    var bodyStyles = window.getComputedStyle(document.body);
    var initialBodyOverflow = bodyStyles.overflowY;
    addClasses$1(container, popup, params); // scrolling is 'hidden' until animation is done, after that 'auto'

    setScrollingVisibility(container, popup);

    if (isModal()) {
      fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
      setAriaHidden();
    }

    if (!isToast() && !globalState.previousActiveElement) {
      globalState.previousActiveElement = document.activeElement;
    }

    if (typeof params.onOpen === 'function') {
      setTimeout(function () {
        return params.onOpen(popup);
      });
    }

    removeClass(container, swalClasses['no-transition']);
  };

  function swalOpenAnimationFinished(event) {
    var popup = getPopup();

    if (event.target !== popup) {
      return;
    }

    var container = getContainer();
    popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
    container.style.overflowY = 'auto';
  }

  var setScrollingVisibility = function setScrollingVisibility(container, popup) {
    if (animationEndEvent && hasCssAnimation(popup)) {
      container.style.overflowY = 'hidden';
      popup.addEventListener(animationEndEvent, swalOpenAnimationFinished);
    } else {
      container.style.overflowY = 'auto';
    }
  };

  var fixScrollContainer = function fixScrollContainer(container, scrollbarPadding, initialBodyOverflow) {
    iOSfix();
    IEfix();

    if (scrollbarPadding && initialBodyOverflow !== 'hidden') {
      fixScrollbar();
    } // sweetalert2/issues/1247


    setTimeout(function () {
      container.scrollTop = 0;
    });
  };

  var addClasses$1 = function addClasses(container, popup, params) {
    addClass(container, params.showClass.backdrop);
    show(popup); // Animate popup right after showing it

    addClass(popup, params.showClass.popup);
    addClass([document.documentElement, document.body], swalClasses.shown);

    if (params.heightAuto && params.backdrop && !params.toast) {
      addClass([document.documentElement, document.body], swalClasses['height-auto']);
    }
  };

  var handleInputOptionsAndValue = function handleInputOptionsAndValue(instance, params) {
    if (params.input === 'select' || params.input === 'radio') {
      handleInputOptions(instance, params);
    } else if (['text', 'email', 'number', 'tel', 'textarea'].indexOf(params.input) !== -1 && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
      handleInputValue(instance, params);
    }
  };
  var getInputValue = function getInputValue(instance, innerParams) {
    var input = instance.getInput();

    if (!input) {
      return null;
    }

    switch (innerParams.input) {
      case 'checkbox':
        return getCheckboxValue(input);

      case 'radio':
        return getRadioValue(input);

      case 'file':
        return getFileValue(input);

      default:
        return innerParams.inputAutoTrim ? input.value.trim() : input.value;
    }
  };

  var getCheckboxValue = function getCheckboxValue(input) {
    return input.checked ? 1 : 0;
  };

  var getRadioValue = function getRadioValue(input) {
    return input.checked ? input.value : null;
  };

  var getFileValue = function getFileValue(input) {
    return input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
  };

  var handleInputOptions = function handleInputOptions(instance, params) {
    var content = getContent();

    var processInputOptions = function processInputOptions(inputOptions) {
      return populateInputOptions[params.input](content, formatInputOptions(inputOptions), params);
    };

    if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
      showLoading();
      asPromise(params.inputOptions).then(function (inputOptions) {
        instance.hideLoading();
        processInputOptions(inputOptions);
      });
    } else if (_typeof(params.inputOptions) === 'object') {
      processInputOptions(params.inputOptions);
    } else {
      error("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(_typeof(params.inputOptions)));
    }
  };

  var handleInputValue = function handleInputValue(instance, params) {
    var input = instance.getInput();
    hide(input);
    asPromise(params.inputValue).then(function (inputValue) {
      input.value = params.input === 'number' ? parseFloat(inputValue) || 0 : "".concat(inputValue);
      show(input);
      input.focus();
      instance.hideLoading();
    })["catch"](function (err) {
      error("Error in inputValue promise: ".concat(err));
      input.value = '';
      show(input);
      input.focus();
      instance.hideLoading();
    });
  };

  var populateInputOptions = {
    select: function select(content, inputOptions, params) {
      var select = getChildByClass(content, swalClasses.select);

      var renderOption = function renderOption(parent, optionLabel, optionValue) {
        var option = document.createElement('option');
        option.value = optionValue;
        setInnerHtml(option, optionLabel);

        if (params.inputValue.toString() === optionValue.toString()) {
          option.selected = true;
        }

        parent.appendChild(option);
      };

      inputOptions.forEach(function (inputOption) {
        var optionValue = inputOption[0];
        var optionLabel = inputOption[1]; // <optgroup> spec:
        // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
        // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
        // check whether this is a <optgroup>

        if (Array.isArray(optionLabel)) {
          // if it is an array, then it is an <optgroup>
          var optgroup = document.createElement('optgroup');
          optgroup.label = optionValue;
          optgroup.disabled = false; // not configurable for now

          select.appendChild(optgroup);
          optionLabel.forEach(function (o) {
            return renderOption(optgroup, o[1], o[0]);
          });
        } else {
          // case of <option>
          renderOption(select, optionLabel, optionValue);
        }
      });
      select.focus();
    },
    radio: function radio(content, inputOptions, params) {
      var radio = getChildByClass(content, swalClasses.radio);
      inputOptions.forEach(function (inputOption) {
        var radioValue = inputOption[0];
        var radioLabel = inputOption[1];
        var radioInput = document.createElement('input');
        var radioLabelElement = document.createElement('label');
        radioInput.type = 'radio';
        radioInput.name = swalClasses.radio;
        radioInput.value = radioValue;

        if (params.inputValue.toString() === radioValue.toString()) {
          radioInput.checked = true;
        }

        var label = document.createElement('span');
        setInnerHtml(label, radioLabel);
        label.className = swalClasses.label;
        radioLabelElement.appendChild(radioInput);
        radioLabelElement.appendChild(label);
        radio.appendChild(radioLabelElement);
      });
      var radios = radio.querySelectorAll('input');

      if (radios.length) {
        radios[0].focus();
      }
    }
  };
  /**
   * Converts `inputOptions` into an array of `[value, label]`s
   * @param inputOptions
   */

  var formatInputOptions = function formatInputOptions(inputOptions) {
    var result = [];

    if (typeof Map !== 'undefined' && inputOptions instanceof Map) {
      inputOptions.forEach(function (value, key) {
        var valueFormatted = value;

        if (_typeof(valueFormatted) === 'object') {
          // case of <optgroup>
          valueFormatted = formatInputOptions(valueFormatted);
        }

        result.push([key, valueFormatted]);
      });
    } else {
      Object.keys(inputOptions).forEach(function (key) {
        var valueFormatted = inputOptions[key];

        if (_typeof(valueFormatted) === 'object') {
          // case of <optgroup>
          valueFormatted = formatInputOptions(valueFormatted);
        }

        result.push([key, valueFormatted]);
      });
    }

    return result;
  };

  var handleConfirmButtonClick = function handleConfirmButtonClick(instance, innerParams) {
    instance.disableButtons();

    if (innerParams.input) {
      handleConfirmWithInput(instance, innerParams);
    } else {
      confirm(instance, innerParams, true);
    }
  };
  var handleCancelButtonClick = function handleCancelButtonClick(instance, dismissWith) {
    instance.disableButtons();
    dismissWith(DismissReason.cancel);
  };

  var handleConfirmWithInput = function handleConfirmWithInput(instance, innerParams) {
    var inputValue = getInputValue(instance, innerParams);

    if (innerParams.inputValidator) {
      instance.disableInput();
      var validationPromise = Promise.resolve().then(function () {
        return asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage));
      });
      validationPromise.then(function (validationMessage) {
        instance.enableButtons();
        instance.enableInput();

        if (validationMessage) {
          instance.showValidationMessage(validationMessage);
        } else {
          confirm(instance, innerParams, inputValue);
        }
      });
    } else if (!instance.getInput().checkValidity()) {
      instance.enableButtons();
      instance.showValidationMessage(innerParams.validationMessage);
    } else {
      confirm(instance, innerParams, inputValue);
    }
  };

  var succeedWith = function succeedWith(instance, value) {
    instance.closePopup({
      value: value
    });
  };

  var confirm = function confirm(instance, innerParams, value) {
    if (innerParams.showLoaderOnConfirm) {
      showLoading(); // TODO: make showLoading an *instance* method
    }

    if (innerParams.preConfirm) {
      instance.resetValidationMessage();
      var preConfirmPromise = Promise.resolve().then(function () {
        return asPromise(innerParams.preConfirm(value, innerParams.validationMessage));
      });
      preConfirmPromise.then(function (preConfirmValue) {
        if (isVisible(getValidationMessage()) || preConfirmValue === false) {
          instance.hideLoading();
        } else {
          succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
        }
      });
    } else {
      succeedWith(instance, value);
    }
  };

  var addKeydownHandler = function addKeydownHandler(instance, globalState, innerParams, dismissWith) {
    if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = false;
    }

    if (!innerParams.toast) {
      globalState.keydownHandler = function (e) {
        return keydownHandler(instance, e, dismissWith);
      };

      globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
      globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
      globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = true;
    }
  }; // Focus handling

  var setFocus = function setFocus(innerParams, index, increment) {
    var focusableElements = getFocusableElements(); // search for visible elements and select the next possible match

    for (var i = 0; i < focusableElements.length; i++) {
      index = index + increment; // rollover to first item

      if (index === focusableElements.length) {
        index = 0; // go to last item
      } else if (index === -1) {
        index = focusableElements.length - 1;
      }

      return focusableElements[index].focus();
    } // no visible focusable elements, focus the popup


    getPopup().focus();
  };
  var arrowKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Left', 'Right', 'Up', 'Down' // IE11
  ];
  var escKeys = ['Escape', 'Esc' // IE11
  ];

  var keydownHandler = function keydownHandler(instance, e, dismissWith) {
    var innerParams = privateProps.innerParams.get(instance);

    if (innerParams.stopKeydownPropagation) {
      e.stopPropagation();
    } // ENTER


    if (e.key === 'Enter') {
      handleEnter(instance, e, innerParams); // TAB
    } else if (e.key === 'Tab') {
      handleTab(e, innerParams); // ARROWS - switch focus between buttons
    } else if (arrowKeys.indexOf(e.key) !== -1) {
      handleArrows(); // ESC
    } else if (escKeys.indexOf(e.key) !== -1) {
      handleEsc(e, innerParams, dismissWith);
    }
  };

  var handleEnter = function handleEnter(instance, e, innerParams) {
    // #720 #721
    if (e.isComposing) {
      return;
    }

    if (e.target && instance.getInput() && e.target.outerHTML === instance.getInput().outerHTML) {
      if (['textarea', 'file'].indexOf(innerParams.input) !== -1) {
        return; // do not submit
      }

      clickConfirm();
      e.preventDefault();
    }
  };

  var handleTab = function handleTab(e, innerParams) {
    var targetElement = e.target;
    var focusableElements = getFocusableElements();
    var btnIndex = -1;

    for (var i = 0; i < focusableElements.length; i++) {
      if (targetElement === focusableElements[i]) {
        btnIndex = i;
        break;
      }
    }

    if (!e.shiftKey) {
      // Cycle to the next button
      setFocus(innerParams, btnIndex, 1);
    } else {
      // Cycle to the prev button
      setFocus(innerParams, btnIndex, -1);
    }

    e.stopPropagation();
    e.preventDefault();
  };

  var handleArrows = function handleArrows() {
    var confirmButton = getConfirmButton();
    var cancelButton = getCancelButton(); // focus Cancel button if Confirm button is currently focused

    if (document.activeElement === confirmButton && isVisible(cancelButton)) {
      cancelButton.focus(); // and vice versa
    } else if (document.activeElement === cancelButton && isVisible(confirmButton)) {
      confirmButton.focus();
    }
  };

  var handleEsc = function handleEsc(e, innerParams, dismissWith) {
    if (callIfFunction(innerParams.allowEscapeKey)) {
      e.preventDefault();
      dismissWith(DismissReason.esc);
    }
  };

  var handlePopupClick = function handlePopupClick(instance, domCache, dismissWith) {
    var innerParams = privateProps.innerParams.get(instance);

    if (innerParams.toast) {
      handleToastClick(instance, domCache, dismissWith);
    } else {
      // Ignore click events that had mousedown on the popup but mouseup on the container
      // This can happen when the user drags a slider
      handleModalMousedown(domCache); // Ignore click events that had mousedown on the container but mouseup on the popup

      handleContainerMousedown(domCache);
      handleModalClick(instance, domCache, dismissWith);
    }
  };

  var handleToastClick = function handleToastClick(instance, domCache, dismissWith) {
    // Closing toast by internal click
    domCache.popup.onclick = function () {
      var innerParams = privateProps.innerParams.get(instance);

      if (innerParams.showConfirmButton || innerParams.showCancelButton || innerParams.showCloseButton || innerParams.input) {
        return;
      }

      dismissWith(DismissReason.close);
    };
  };

  var ignoreOutsideClick = false;

  var handleModalMousedown = function handleModalMousedown(domCache) {
    domCache.popup.onmousedown = function () {
      domCache.container.onmouseup = function (e) {
        domCache.container.onmouseup = undefined; // We only check if the mouseup target is the container because usually it doesn't
        // have any other direct children aside of the popup

        if (e.target === domCache.container) {
          ignoreOutsideClick = true;
        }
      };
    };
  };

  var handleContainerMousedown = function handleContainerMousedown(domCache) {
    domCache.container.onmousedown = function () {
      domCache.popup.onmouseup = function (e) {
        domCache.popup.onmouseup = undefined; // We also need to check if the mouseup target is a child of the popup

        if (e.target === domCache.popup || domCache.popup.contains(e.target)) {
          ignoreOutsideClick = true;
        }
      };
    };
  };

  var handleModalClick = function handleModalClick(instance, domCache, dismissWith) {
    domCache.container.onclick = function (e) {
      var innerParams = privateProps.innerParams.get(instance);

      if (ignoreOutsideClick) {
        ignoreOutsideClick = false;
        return;
      }

      if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) {
        dismissWith(DismissReason.backdrop);
      }
    };
  };

  function _main(userParams) {
    showWarningsForParams(userParams);

    if (globalState.currentInstance) {
      globalState.currentInstance._destroy();
    }

    globalState.currentInstance = this;
    var innerParams = prepareParams(userParams);
    setParameters(innerParams);
    Object.freeze(innerParams); // clear the previous timer

    if (globalState.timeout) {
      globalState.timeout.stop();
      delete globalState.timeout;
    } // clear the restore focus timeout


    clearTimeout(globalState.restoreFocusTimeout);
    var domCache = populateDomCache(this);
    render(this, innerParams);
    privateProps.innerParams.set(this, innerParams);
    return swalPromise(this, domCache, innerParams);
  }

  var prepareParams = function prepareParams(userParams) {
    var showClass = _extends({}, defaultParams.showClass, userParams.showClass);

    var hideClass = _extends({}, defaultParams.hideClass, userParams.hideClass);

    var params = _extends({}, defaultParams, userParams);

    params.showClass = showClass;
    params.hideClass = hideClass; // @deprecated

    if (userParams.animation === false) {
      params.showClass = {
        popup: 'swal2-noanimation',
        backdrop: 'swal2-noanimation'
      };
      params.hideClass = {};
    }

    return params;
  };

  var swalPromise = function swalPromise(instance, domCache, innerParams) {
    return new Promise(function (resolve) {
      // functions to handle all closings/dismissals
      var dismissWith = function dismissWith(dismiss) {
        instance.closePopup({
          dismiss: dismiss
        });
      };

      privateMethods.swalPromiseResolve.set(instance, resolve);

      domCache.confirmButton.onclick = function () {
        return handleConfirmButtonClick(instance, innerParams);
      };

      domCache.cancelButton.onclick = function () {
        return handleCancelButtonClick(instance, dismissWith);
      };

      domCache.closeButton.onclick = function () {
        return dismissWith(DismissReason.close);
      };

      handlePopupClick(instance, domCache, dismissWith);
      addKeydownHandler(instance, globalState, innerParams, dismissWith);

      if (innerParams.toast && (innerParams.input || innerParams.footer || innerParams.showCloseButton)) {
        addClass(document.body, swalClasses['toast-column']);
      } else {
        removeClass(document.body, swalClasses['toast-column']);
      }

      handleInputOptionsAndValue(instance, innerParams);
      openPopup(innerParams);
      setupTimer(globalState, innerParams, dismissWith);
      initFocus(domCache, innerParams); // Scroll container to top on open (#1247, #1946)

      setTimeout(function () {
        domCache.container.scrollTop = 0;
      });
    });
  };

  var populateDomCache = function populateDomCache(instance) {
    var domCache = {
      popup: getPopup(),
      container: getContainer(),
      content: getContent(),
      actions: getActions(),
      confirmButton: getConfirmButton(),
      cancelButton: getCancelButton(),
      closeButton: getCloseButton(),
      validationMessage: getValidationMessage(),
      progressSteps: getProgressSteps()
    };
    privateProps.domCache.set(instance, domCache);
    return domCache;
  };

  var setupTimer = function setupTimer(globalState$$1, innerParams, dismissWith) {
    var timerProgressBar = getTimerProgressBar();
    hide(timerProgressBar);

    if (innerParams.timer) {
      globalState$$1.timeout = new Timer(function () {
        dismissWith('timer');
        delete globalState$$1.timeout;
      }, innerParams.timer);

      if (innerParams.timerProgressBar) {
        show(timerProgressBar);
        setTimeout(function () {
          if (globalState$$1.timeout.running) {
            // timer can be already stopped at this point
            animateTimerProgressBar(innerParams.timer);
          }
        });
      }
    }
  };

  var initFocus = function initFocus(domCache, innerParams) {
    if (innerParams.toast) {
      return;
    }

    if (!callIfFunction(innerParams.allowEnterKey)) {
      return blurActiveElement();
    }

    if (innerParams.focusCancel && isVisible(domCache.cancelButton)) {
      return domCache.cancelButton.focus();
    }

    if (innerParams.focusConfirm && isVisible(domCache.confirmButton)) {
      return domCache.confirmButton.focus();
    }

    setFocus(innerParams, -1, 1);
  };

  var blurActiveElement = function blurActiveElement() {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
  };

  /**
   * Updates popup parameters.
   */

  function update(params) {
    var popup = getPopup();
    var innerParams = privateProps.innerParams.get(this);

    if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
      return warn("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    }

    var validUpdatableParams = {}; // assign valid params from `params` to `defaults`

    Object.keys(params).forEach(function (param) {
      if (Swal.isUpdatableParameter(param)) {
        validUpdatableParams[param] = params[param];
      } else {
        warn("Invalid parameter to update: \"".concat(param, "\". Updatable params are listed here: https://github.com/sweetalert2/sweetalert2/blob/master/src/utils/params.js"));
      }
    });

    var updatedParams = _extends({}, innerParams, validUpdatableParams);

    render(this, updatedParams);
    privateProps.innerParams.set(this, updatedParams);
    Object.defineProperties(this, {
      params: {
        value: _extends({}, this.params, params),
        writable: false,
        enumerable: true
      }
    });
  }

  function _destroy() {
    var domCache = privateProps.domCache.get(this);
    var innerParams = privateProps.innerParams.get(this);

    if (!innerParams) {
      return; // This instance has already been destroyed
    } // Check if there is another Swal closing


    if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
      globalState.swalCloseEventFinishedCallback();
      delete globalState.swalCloseEventFinishedCallback;
    } // Check if there is a swal disposal defer timer


    if (globalState.deferDisposalTimer) {
      clearTimeout(globalState.deferDisposalTimer);
      delete globalState.deferDisposalTimer;
    }

    if (typeof innerParams.onDestroy === 'function') {
      innerParams.onDestroy();
    }

    disposeSwal(this);
  }

  var disposeSwal = function disposeSwal(instance) {
    // Unset this.params so GC will dispose it (#1569)
    delete instance.params; // Unset globalState props so GC will dispose globalState (#1569)

    delete globalState.keydownHandler;
    delete globalState.keydownTarget; // Unset WeakMaps so GC will be able to dispose them (#1569)

    unsetWeakMaps(privateProps);
    unsetWeakMaps(privateMethods);
  };

  var unsetWeakMaps = function unsetWeakMaps(obj) {
    for (var i in obj) {
      obj[i] = new WeakMap();
    }
  };



  var instanceMethods = /*#__PURE__*/Object.freeze({
    hideLoading: hideLoading,
    disableLoading: hideLoading,
    getInput: getInput$1,
    close: close,
    closePopup: close,
    closeModal: close,
    closeToast: close,
    enableButtons: enableButtons,
    disableButtons: disableButtons,
    enableInput: enableInput,
    disableInput: disableInput,
    showValidationMessage: showValidationMessage,
    resetValidationMessage: resetValidationMessage$1,
    getProgressSteps: getProgressSteps$1,
    _main: _main,
    update: update,
    _destroy: _destroy
  });

  var currentInstance;

  var SweetAlert = /*#__PURE__*/function () {
    function SweetAlert() {
      _classCallCheck(this, SweetAlert);

      // Prevent run in Node env
      if (typeof window === 'undefined') {
        return;
      } // Check for the existence of Promise


      if (typeof Promise === 'undefined') {
        error('This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)');
      }

      currentInstance = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var outerParams = Object.freeze(this.constructor.argsToParams(args));
      Object.defineProperties(this, {
        params: {
          value: outerParams,
          writable: false,
          enumerable: true,
          configurable: true
        }
      });

      var promise = this._main(this.params);

      privateProps.promise.set(this, promise);
    } // `catch` cannot be the name of a module export, so we define our thenable methods here instead


    _createClass(SweetAlert, [{
      key: "then",
      value: function then(onFulfilled) {
        var promise = privateProps.promise.get(this);
        return promise.then(onFulfilled);
      }
    }, {
      key: "finally",
      value: function _finally(onFinally) {
        var promise = privateProps.promise.get(this);
        return promise["finally"](onFinally);
      }
    }]);

    return SweetAlert;
  }(); // Assign instance methods from src/instanceMethods/*.js to prototype


  _extends(SweetAlert.prototype, instanceMethods); // Assign static methods from src/staticMethods/*.js to constructor


  _extends(SweetAlert, staticMethods); // Proxy to instance methods to constructor, for now, for backwards compatibility


  Object.keys(instanceMethods).forEach(function (key) {
    SweetAlert[key] = function () {
      if (currentInstance) {
        var _currentInstance;

        return (_currentInstance = currentInstance)[key].apply(_currentInstance, arguments);
      }
    };
  });
  SweetAlert.DismissReason = DismissReason;
  SweetAlert.version = '9.17.2';

  var Swal = SweetAlert;
  Swal["default"] = Swal;

  return Swal;

}));
if (typeof this !== 'undefined' && this.Sweetalert2){  this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2}

"undefined"!=typeof document&&function(e,t){var n=e.createElement("style");if(e.getElementsByTagName("head")[0].appendChild(n),n.styleSheet)n.styleSheet.disabled||(n.styleSheet.cssText=t);else try{n.innerHTML=t}catch(e){n.innerText=t}}(document,".swal2-popup.swal2-toast{flex-direction:row;align-items:center;width:auto;padding:.625em;overflow-y:hidden;background:#fff;box-shadow:0 0 .625em #d9d9d9}.swal2-popup.swal2-toast .swal2-header{flex-direction:row;padding:0}.swal2-popup.swal2-toast .swal2-title{flex-grow:1;justify-content:flex-start;margin:0 .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{position:static;width:.8em;height:.8em;line-height:.8}.swal2-popup.swal2-toast .swal2-content{justify-content:flex-start;padding:0;font-size:1em}.swal2-popup.swal2-toast .swal2-icon{width:2em;min-width:2em;height:2em;margin:0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:700}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{font-size:.25em}}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{flex-basis:auto!important;width:auto;height:auto;margin:0 .3125em}.swal2-popup.swal2-toast .swal2-styled{margin:0 .3125em;padding:.3125em .625em;font-size:1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(50,100,150,.4)}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.8em;left:-.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-toast-animate-success-line-tip .75s;animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-toast-animate-success-line-long .75s;animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{-webkit-animation:swal2-toast-show .5s;animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation:swal2-toast-hide .1s forwards;animation:swal2-toast-hide .1s forwards}.swal2-container{display:flex;position:fixed;z-index:1060;top:0;right:0;bottom:0;left:0;flex-direction:row;align-items:center;justify-content:center;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}.swal2-container.swal2-backdrop-show,.swal2-container.swal2-noanimation{background:rgba(0,0,0,.4)}.swal2-container.swal2-backdrop-hide{background:0 0!important}.swal2-container.swal2-top{align-items:flex-start}.swal2-container.swal2-top-left,.swal2-container.swal2-top-start{align-items:flex-start;justify-content:flex-start}.swal2-container.swal2-top-end,.swal2-container.swal2-top-right{align-items:flex-start;justify-content:flex-end}.swal2-container.swal2-center{align-items:center}.swal2-container.swal2-center-left,.swal2-container.swal2-center-start{align-items:center;justify-content:flex-start}.swal2-container.swal2-center-end,.swal2-container.swal2-center-right{align-items:center;justify-content:flex-end}.swal2-container.swal2-bottom{align-items:flex-end}.swal2-container.swal2-bottom-left,.swal2-container.swal2-bottom-start{align-items:flex-end;justify-content:flex-start}.swal2-container.swal2-bottom-end,.swal2-container.swal2-bottom-right{align-items:flex-end;justify-content:flex-end}.swal2-container.swal2-bottom-end>:first-child,.swal2-container.swal2-bottom-left>:first-child,.swal2-container.swal2-bottom-right>:first-child,.swal2-container.swal2-bottom-start>:first-child,.swal2-container.swal2-bottom>:first-child{margin-top:auto}.swal2-container.swal2-grow-fullscreen>.swal2-modal{display:flex!important;flex:1;align-self:stretch;justify-content:center}.swal2-container.swal2-grow-row>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container.swal2-grow-column{flex:1;flex-direction:column}.swal2-container.swal2-grow-column.swal2-bottom,.swal2-container.swal2-grow-column.swal2-center,.swal2-container.swal2-grow-column.swal2-top{align-items:center}.swal2-container.swal2-grow-column.swal2-bottom-left,.swal2-container.swal2-grow-column.swal2-bottom-start,.swal2-container.swal2-grow-column.swal2-center-left,.swal2-container.swal2-grow-column.swal2-center-start,.swal2-container.swal2-grow-column.swal2-top-left,.swal2-container.swal2-grow-column.swal2-top-start{align-items:flex-start}.swal2-container.swal2-grow-column.swal2-bottom-end,.swal2-container.swal2-grow-column.swal2-bottom-right,.swal2-container.swal2-grow-column.swal2-center-end,.swal2-container.swal2-grow-column.swal2-center-right,.swal2-container.swal2-grow-column.swal2-top-end,.swal2-container.swal2-grow-column.swal2-top-right{align-items:flex-end}.swal2-container.swal2-grow-column>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container.swal2-no-transition{transition:none!important}.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)>.swal2-modal{margin:auto}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-container .swal2-modal{margin:0!important}}.swal2-popup{display:none;position:relative;box-sizing:border-box;flex-direction:column;justify-content:center;width:32em;max-width:100%;padding:1.25em;border:none;border-radius:.3125em;background:#fff;font-family:inherit;font-size:1rem}.swal2-popup:focus{outline:0}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-header{display:flex;flex-direction:column;align-items:center;padding:0 1.8em}.swal2-title{position:relative;max-width:100%;margin:0 0 .4em;padding:0;color:#595959;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-actions{display:flex;z-index:1;flex-wrap:wrap;align-items:center;justify-content:center;width:100%;margin:1.25em auto 0}.swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}.swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}.swal2-actions.swal2-loading .swal2-styled.swal2-confirm{box-sizing:border-box;width:2.5em;height:2.5em;margin:.46875em;padding:0;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border:.25em solid transparent;border-radius:100%;border-color:transparent;background-color:transparent!important;color:transparent!important;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-actions.swal2-loading .swal2-styled.swal2-cancel{margin-right:30px;margin-left:30px}.swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm::after{content:\"\";display:inline-block;width:15px;height:15px;margin-left:5px;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border:3px solid #999;border-radius:50%;border-right-color:transparent;box-shadow:1px 1px 1px #fff}.swal2-styled{margin:.3125em;padding:.625em 2em;box-shadow:none;font-weight:500}.swal2-styled:not([disabled]){cursor:pointer}.swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#3085d6;color:#fff;font-size:1.0625em}.swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#aaa;color:#fff;font-size:1.0625em}.swal2-styled:focus{outline:0;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(50,100,150,.4)}.swal2-styled::-moz-focus-inner{border:0}.swal2-footer{justify-content:center;margin:1.25em 0 0;padding:1em 0 0;border-top:1px solid #eee;color:#545454;font-size:1em}.swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;height:.25em;overflow:hidden;border-bottom-right-radius:.3125em;border-bottom-left-radius:.3125em}.swal2-timer-progress-bar{width:100%;height:.25em;background:rgba(0,0,0,.2)}.swal2-image{max-width:100%;margin:1.25em auto}.swal2-close{position:absolute;z-index:2;top:0;right:0;align-items:center;justify-content:center;width:1.2em;height:1.2em;padding:0;overflow:hidden;transition:color .1s ease-out;border:none;border-radius:0;background:0 0;color:#ccc;font-family:serif;font-size:2.5em;line-height:1.2;cursor:pointer}.swal2-close:hover{transform:none;background:0 0;color:#f27474}.swal2-close::-moz-focus-inner{border:0}.swal2-content{z-index:1;justify-content:center;margin:0;padding:0 1.6em;color:#545454;font-size:1.125em;font-weight:400;line-height:normal;text-align:center;word-wrap:break-word}.swal2-checkbox,.swal2-file,.swal2-input,.swal2-radio,.swal2-select,.swal2-textarea{margin:1em auto}.swal2-file,.swal2-input,.swal2-textarea{box-sizing:border-box;width:100%;transition:border-color .3s,box-shadow .3s;border:1px solid #d9d9d9;border-radius:.1875em;background:inherit;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);color:inherit;font-size:1.125em}.swal2-file.swal2-inputerror,.swal2-input.swal2-inputerror,.swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-file:focus,.swal2-input:focus,.swal2-textarea:focus{border:1px solid #b4dbed;outline:0;box-shadow:0 0 3px #c4e6f5}.swal2-file::-moz-placeholder,.swal2-input::-moz-placeholder,.swal2-textarea::-moz-placeholder{color:#ccc}.swal2-file:-ms-input-placeholder,.swal2-input:-ms-input-placeholder,.swal2-textarea:-ms-input-placeholder{color:#ccc}.swal2-file::-ms-input-placeholder,.swal2-input::-ms-input-placeholder,.swal2-textarea::-ms-input-placeholder{color:#ccc}.swal2-file::placeholder,.swal2-input::placeholder,.swal2-textarea::placeholder{color:#ccc}.swal2-range{margin:1em auto;background:#fff}.swal2-range input{width:80%}.swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}.swal2-range input,.swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}.swal2-input{height:2.625em;padding:0 .75em}.swal2-input[type=number]{max-width:10em}.swal2-file{background:inherit;font-size:1.125em}.swal2-textarea{height:6.75em;padding:.75em}.swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:inherit;color:inherit;font-size:1.125em}.swal2-checkbox,.swal2-radio{align-items:center;justify-content:center;background:#fff;color:inherit}.swal2-checkbox label,.swal2-radio label{margin:0 .6em;font-size:1.125em}.swal2-checkbox input,.swal2-radio input{margin:0 .4em}.swal2-validation-message{display:none;align-items:center;justify-content:center;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}.swal2-validation-message::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}.swal2-icon{position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:1.25em auto 1.875em;border:.25em solid transparent;border-radius:50%;font-family:inherit;line-height:5em;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474;color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}.swal2-icon.swal2-error.swal2-icon-show{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark{-webkit-animation:swal2-animate-error-x-mark .5s;animation:swal2-animate-error-x-mark .5s}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-success{border-color:#a5dc86;color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-.25em;left:-.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-animate-success-line-tip .75s;animation:swal2-animate-success-line-tip .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-animate-success-line-long .75s;animation:swal2-animate-success-line-long .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right{-webkit-animation:swal2-rotate-success-circular-line 4.25s ease-in;animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-progress-steps{align-items:center;margin:0 0 1.25em;padding:0;background:inherit;font-weight:600}.swal2-progress-steps li{display:inline-block;position:relative}.swal2-progress-steps .swal2-progress-step{z-index:20;width:2em;height:2em;border-radius:2em;background:#3085d6;color:#fff;line-height:2em;text-align:center}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#3085d6}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}.swal2-progress-steps .swal2-progress-step-line{z-index:10;width:2.5em;height:.4em;margin:0 -1px;background:#3085d6}[class^=swal2]{-webkit-tap-highlight-color:transparent}.swal2-show{-webkit-animation:swal2-show .3s;animation:swal2-show .3s}.swal2-hide{-webkit-animation:swal2-hide .15s forwards;animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{right:auto;left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@-moz-document url-prefix(){.swal2-close:focus{outline:2px solid rgba(50,100,150,.4)}}@-webkit-keyframes swal2-toast-show{0%{transform:translateY(-.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0)}}@keyframes swal2-toast-show{0%{transform:translateY(-.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0)}}@-webkit-keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@-webkit-keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@-webkit-keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@-webkit-keyframes swal2-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}100%{transform:scale(1)}}@keyframes swal2-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}100%{transform:scale(1)}}@-webkit-keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(.5);opacity:0}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(.5);opacity:0}}@-webkit-keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@-webkit-keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@-webkit-keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@-webkit-keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(.4);opacity:0}50%{margin-top:1.625em;transform:scale(.4);opacity:0}80%{margin-top:-.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(.4);opacity:0}50%{margin-top:1.625em;transform:scale(.4);opacity:0}80%{margin-top:-.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@-webkit-keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0);opacity:1}}@-webkit-keyframes swal2-rotate-loading{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes swal2-rotate-loading{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto!important}body.swal2-no-backdrop .swal2-container{top:auto;right:auto;bottom:auto;left:auto;max-width:calc(100% - .625em * 2);background-color:transparent!important}body.swal2-no-backdrop .swal2-container>.swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}body.swal2-no-backdrop .swal2-container.swal2-top{top:0;left:50%;transform:translateX(-50%)}body.swal2-no-backdrop .swal2-container.swal2-top-left,body.swal2-no-backdrop .swal2-container.swal2-top-start{top:0;left:0}body.swal2-no-backdrop .swal2-container.swal2-top-end,body.swal2-no-backdrop .swal2-container.swal2-top-right{top:0;right:0}body.swal2-no-backdrop .swal2-container.swal2-center{top:50%;left:50%;transform:translate(-50%,-50%)}body.swal2-no-backdrop .swal2-container.swal2-center-left,body.swal2-no-backdrop .swal2-container.swal2-center-start{top:50%;left:0;transform:translateY(-50%)}body.swal2-no-backdrop .swal2-container.swal2-center-end,body.swal2-no-backdrop .swal2-container.swal2-center-right{top:50%;right:0;transform:translateY(-50%)}body.swal2-no-backdrop .swal2-container.swal2-bottom{bottom:0;left:50%;transform:translateX(-50%)}body.swal2-no-backdrop .swal2-container.swal2-bottom-left,body.swal2-no-backdrop .swal2-container.swal2-bottom-start{bottom:0;left:0}body.swal2-no-backdrop .swal2-container.swal2-bottom-end,body.swal2-no-backdrop .swal2-container.swal2-bottom-right{right:0;bottom:0}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll!important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static!important}}body.swal2-toast-shown .swal2-container{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-top{top:0;right:auto;bottom:auto;left:50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top:0;right:0;bottom:auto;left:auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top:0;right:auto;bottom:auto;left:0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top:50%;right:auto;bottom:auto;left:0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top:50%;right:auto;bottom:auto;left:50%;transform:translate(-50%,-50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top:50%;right:0;bottom:auto;left:auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top:auto;right:auto;bottom:0;left:0}body.swal2-toast-shown .swal2-container.swal2-bottom{top:auto;right:auto;bottom:0;left:50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top:auto;right:0;bottom:0;left:auto}body.swal2-toast-column .swal2-toast{flex-direction:column;align-items:stretch}body.swal2-toast-column .swal2-toast .swal2-actions{flex:1;align-self:stretch;height:2.2em;margin-top:.3125em}body.swal2-toast-column .swal2-toast .swal2-loading{justify-content:center}body.swal2-toast-column .swal2-toast .swal2-input{height:2em;margin:.3125em auto;font-size:1em}body.swal2-toast-column .swal2-toast .swal2-validation-message{font-size:1em}");

/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  baseURL: "https://centralize.maeriminterfood.com",
  baseURLV2: "https://marim-mis-api.maeriminterfood.com"
  // baseURLV2: 'https://marim-api-test.undefined.co.th:4439'
  // baseURLV2: "http://localhost:6100"
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  addSale: function addSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateSale: function UpdateSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdBill: function holdBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/holdbill', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openShift: function openShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/open', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  closeShift: function closeShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/close', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShiftDetail: function getHostShiftDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/details', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billList: function billList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBill: function printBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/cash/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printHolding: function printHolding(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/hold/slip', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/hold/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBillCredit: function printBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/credit/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPaybill: function printPaybill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSaleOnHost: function getSaleOnHost(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/cancel', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHoldingBill: function getHoldingBill(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/holdbill/list', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/hold/bill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getReportBill: function getReportBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  ExportMoney: function ExportMoney(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/expense/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  PrintCloseShif: function PrintCloseShif(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/shift/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openCashBox: function openCashBox(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/open/cashbox', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveList: function receiveList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveCancel: function receiveCancel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveById: function receiveById(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditList: function billCreditList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/bill/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveNew: function receiveNew(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveUpdate: function receiveUpdate(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptSearch: function receiptSearch(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDetail: function receiptDetail(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDel: function receiptDel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  payBillCredit: function payBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPayBillCredit: function printPayBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosByDoc: function getPosByDoc(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosList: function getPosList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/return/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  configDetail: function configDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditDetail: function billCreditDetail(URL, header, body, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/print/data', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/print/data', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billReceiptDetail: function billReceiptDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipExpend: function slipExpend(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/expense/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipIncome: function slipIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/income/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkReturn: function checkReturn(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/check/return', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1104);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  saveSettingRice: function saveSettingRice(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/settingrice/save', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  selectSettingRice: function selectSettingRice(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/settingrice', header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  selectRiceSummeryByDate: function selectRiceSummeryByDate(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/ricesummery/bydate', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  selectRiceSummeryByDateAllBranch: function selectRiceSummeryByDateAllBranch(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/ricesummery/bydateandallbranch', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  selectRemainStock: function selectRemainStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/remainstock/bydate', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  updateRemainStock: function updateRemainStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/remainstock/update', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  saveRemainStock: function saveRemainStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/remainstock/save', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  deleteRemainStock: function deleteRemainStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/remainstock/delete', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  changeRemainStock: function changeRemainStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/remainstock/change', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  deleteStockandRemain: function deleteStockandRemain(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/ricesummery/deletestockandremain', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  selectTransferStock: function selectTransferStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/selecttranfer', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  approveTransferStock: function approveTransferStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/approvetransfer', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  cancelTransferStock: function cancelTransferStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/canceltransfer', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getHaveStock: function getHaveStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/getbranchhavestock', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  branchSetting: function branchSetting(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/branchsetting', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  shortStock: function shortStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/shortstock', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  changeActivity: function changeActivity(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/changeactivity', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  confirmActivity: function confirmActivity(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/confirmActivity', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  updateShortStock: function updateShortStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/updateshortstock', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  reportInvoice: function reportInvoice(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/reportInvoice', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  reportInvoiceSelect: function reportInvoiceSelect(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/reportInvoiceSelect', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getStocks: function getStocks(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/stock/getstocks', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  resetStock: function resetStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/stock/resetstock', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  deleteProduct: function deleteProduct(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/product/deleteproduct', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  resetStockEgg: function resetStockEgg(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/stock/mis/resetstockegg', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getStockEgg: function getStockEgg(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/stock/mis/getstockegg', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  createInvoice: function createInvoice(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/invoice/createinvoice', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getInvoice: function getInvoice(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/invoice/getinvoice', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  cancelInvoice: function cancelInvoice(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/invoice/cancelinvoice', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  cancelTransferStockWhenApprove: function cancelTransferStockWhenApprove(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/cancelTransferStockWhenApprove', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  updateSale: function updateSale(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/sales/updateSale', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getProductAll: function getProductAll(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/product/getproductall', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  insertWaitingTransferStock: function insertWaitingTransferStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/inserttransfer', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  selectTransferBranch: function selectTransferBranch(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/selectTransferBranch', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  approveOutTransfer: function approveOutTransfer(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/approveOutTransfer', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  approveInTransfer: function approveInTransfer(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/mis/approveInTransfer', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  reportsYearlyCost: function reportsYearlyCost(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/reports/yearlycost', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  reportsSaleSummery: function reportsSaleSummery(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/reports/reportSaleSummery', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  reportsCalculateRice: function reportsCalculateRice(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/reports/reportCalculateRice', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_report__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_undefined_v2__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['host', 'startDate', 'endDate', 'branch', 'startTime', 'endTime'],
  data: function data() {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.host),
      users: this.$store.state.user.username
    };
  },

  methods: {
    getReport: function getReport() {
      var _this = this;

      var branch = 0;
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: 1,
        id: branch,
        begin_date: this.dateDMY(this.startDate) + ' ' + this.startTime,
        end_date: this.dateDMY(this.endDate) + ' ' + this.endTime
      };
      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_2__services_service_report__["a" /* default */].saleDetail(sessionStorage.Url, this.header, obj, function (result) {
        _this.$store.commit('Loading');
        if (result.response === 'success') {
          console.log(result.data);

          _this.report_data = result.data;
          _this.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        _this.$notification['warning']({
          message: 'ไม่สามารถเข้าถึงข้อมูล',
          description: 'API น่าจะ panic'
        });
        console.log('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    },
    updateSale: function updateSale(docno) {
      var _this2 = this;

      var branch = 0;
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        branch_id: branch,
        doc_no: docno
      };

      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
        title: 'ลบข้อมูลบิลขายสินค้า',
        text: 'ท่านต้องการลบข้อมูลบิลขายสินค้า ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ปฏิเสธ',
        cancelButtonColor: 'red',
        reverseButtons: true
      }).then(function (result) {
        if (result.isConfirmed) {

          // console.log(this.report_data[0].filter((e) => e.doc_no !== '01-P670703-0001'));

          _this2.$store.commit("Loading");
          __WEBPACK_IMPORTED_MODULE_3__services_service_undefined_v2__["a" /* default */].updateSale(obj, _this2.header, function (results) {
            if (results.data.status) {
              __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                icon: "success",
                title: "ทำรายการสำเร็จ",
                showConfirmButton: false,
                timer: 4000
              }).then(function () {
                if (_this2.report_data.length > 0) {
                  _this2.report_data[0] = _this2.report_data[0].filter(function (e) {
                    return e.doc_no !== docno;
                  });
                  _this2.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.report_data);
                }
              });
            } else {
              _this2.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", "");
            }
            _this2.$store.commit("Loading");
          }, function (errors) {
            _this2.$store.commit("Loading");
            // this.$store.commit("Loading");
            _this2.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
          });
        }
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format('HH:mm:ss');
    },
    sum_qty: function sum_qty(obj) {
      var sumQty = 0;
      obj.forEach(function (val) {
        sumQty += val['cn_qty'];
      });
      return sumQty;
    },
    sum_total: function sum_total(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['total_amount'];
      });
      return sum;
    }
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.getReport()
    // }, 500)
  }
});

/***/ }),

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_report__ = __webpack_require__(1102);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['host', 'startDate', 'endDate', 'branch', 'startTime', 'endTime'],
  data: function data() {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.host)
    };
  },

  methods: {
    getReport: function getReport() {
      var _this = this;

      var branch = 0;
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: 1,
        id: branch,
        begin_date: this.dateDMY(this.startDate) + ' ' + this.startTime,
        end_date: this.dateDMY(this.endDate) + ' ' + this.endTime
      };
      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_2__services_service_report__["a" /* default */].salePosDetail(sessionStorage.Url, this.header, obj, function (result) {
        _this.$store.commit('Loading');
        if (result.response === 'success') {
          _this.report_data = result.data;
          _this.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        _this.$notification['warning']({
          message: 'ไม่สามารถเข้าถึงข้อมูล',
          description: 'API น่าจะ panic'
        });
        console.log('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format('HH:mm:ss');
    },
    sum_qty: function sum_qty(obj) {
      var sumQty = 0;
      obj.forEach(function (val) {
        sumQty += val['cn_qty'];
      });
      return sumQty;
    },
    sum_total: function sum_total(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['total_amount'];
      });
      return sum;
    }
  },
  mounted: function mounted() {
    // this.getReport()
  }
});

/***/ }),

/***/ 1121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_report__ = __webpack_require__(1102);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['host', 'startDate', 'endDate', 'branch', 'startTime', 'endTime'],
  data: function data() {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.host)
    };
  },

  methods: {
    getReport: function getReport() {
      var _this = this;

      var branch = 0;
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: 1,
        id: branch,
        begin_date: this.dateDMY(this.startDate) + ' ' + this.startTime,
        end_date: this.dateDMY(this.endDate) + ' ' + this.endTime
      };
      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_2__services_service_report__["a" /* default */].saleCreditDetail(sessionStorage.Url, this.header, obj, function (result) {
        _this.$store.commit('Loading');
        if (result.response === 'success') {
          _this.report_data = result.data;
          _this.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        _this.$notification['warning']({
          message: 'ไม่สามารถเข้าถึงข้อมูล',
          description: 'API น่าจะ panic'
        });
        console.log('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format('HH:mm:ss');
    },
    sum_qty: function sum_qty(obj) {
      var sumQty = 0;
      obj.forEach(function (val) {
        sumQty += val['cn_qty'];
      });
      return sumQty;
    },
    sum_total: function sum_total(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['total_amount'];
      });
      return sum;
    }
  },
  mounted: function mounted() {
    // this.getReport()
  }
});

/***/ }),

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_report__ = __webpack_require__(1102);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['host', 'startDate', 'endDate', 'branch', 'startTime', 'endTime'],
  data: function data() {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.host)
    };
  },

  methods: {
    getReport: function getReport() {
      var _this = this;

      var branch = 0;
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: 1,
        id: branch,
        begin_date: this.dateDMY(this.startDate) + ' ' + this.startTime,
        end_date: this.dateDMY(this.endDate) + ' ' + this.endTime
      };
      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_2__services_service_report__["a" /* default */].saleHoldDetail(sessionStorage.Url, this.header, obj, function (result) {
        _this.$store.commit('Loading');
        if (result.response === 'success') {
          _this.report_data = result.data;
          _this.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        _this.$notification['warning']({
          message: 'ไม่สามารถเข้าถึงข้อมูล',
          description: 'API น่าจะ panic'
        });
        console.log('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format('HH:mm:ss');
    },
    sum_qty: function sum_qty(obj) {
      var sumQty = 0;
      obj.forEach(function (val) {
        sumQty += val['cn_qty'];
      });
      return sumQty;
    },
    sum_total: function sum_total(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['total_amount'];
      });
      return sum;
    }
  },
  mounted: function mounted() {
    // this.getReport()
  }
});

/***/ }),

/***/ 1123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_report__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_undefined_v2__ = __webpack_require__(1106);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['host', 'startDate', 'endDate', 'branch'],
  data: function data() {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.host)
    };
  },

  methods: {
    test: function test() {
      console.log(this.form_data);
    },
    getReport: function getReport() {
      var _this = this;

      this.report_data = {};
      var branch = 0;
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: 1,
        id: branch,
        begin_date: this.dateFormatDMY2(this.startDate),
        end_date: this.dateFormatDMY2(this.endDate)
      };
      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_2__services_service_report__["a" /* default */].saleSummary(sessionStorage.Url, this.header, obj, function (result) {

        if (result.response === 'success') {

          var obj = {
            start_date: _this.dateFormatDMY2(_this.startDate), // Set formatted start date
            end_date: _this.dateFormatDMY2(_this.endDate), // Set formatted end date
            branch_id: branch
          };

          __WEBPACK_IMPORTED_MODULE_3__services_service_undefined_v2__["a" /* default */].reportsSaleSummery(obj, _this.header, function (results) {
            // this.$store.state.isLoading = false
            if (results.status) {
              _this.$store.commit('Loading');
              console.log(result.data);
              _this.report_data = result.data;
              result.data.map(function (e) {
                e.map(function (ex) {

                  var branchData = results.data.data.find(function (b) {
                    return b.branch_id === branch;
                  });

                  if (branchData) {
                    var exDate = new Date(new Date(ex.doc_date).getTime() + 24 * 60 * 60 * 1000).toISOString().split("T")[0];

                    var match = branchData.results.find(function (e) {
                      return e.doc_date === exDate;
                    });
                    // console.log("doc_date", e.doc_date);
                    console.log("exDate", exDate);
                    console.log(match);
                    if (match) {
                      console.log(ex.total_amount);
                      ex.total_amount -= match.amount;
                      ex.price_product_not_tax -= match.amount;
                      ex.item_amount -= match.amount;
                      console.log(ex.total_amount);
                    }
                  }

                  if (ex.branch_name === 'สาขาธานินท์') {
                    ex.branch_name = 'สาขาธานินท์ ' + '(00001)';
                  } else if (ex.branch_name === 'สาขาต้นพยอม') {
                    ex.branch_name = 'สาขาต้นพยอม ' + '(00002)';
                  } else if (ex.branch_name === 'สาขาจอมทอง') {
                    ex.branch_name = 'สาขาจอมทอง ' + '(00003)';
                  } else if (ex.branch_name === 'สาขาบ่อสร้าง') {
                    ex.branch_name = 'สาขาบ่อสร้าง ' + '(00004)';
                  } else if (ex.branch_name === 'สาขาป่าเหมือด') {
                    ex.branch_name = 'สาขาป่าเหมือด ' + '(00005)';
                  } else if (ex.branch_name === 'สาขาศรีบุญยืน') {
                    ex.branch_name = 'สาขาศรีบุญยืน ' + '(00006)';
                  } else if (ex.branch_name === 'สาขาหนองกระทิง') {
                    ex.branch_name = 'สาขาหนองกระทิง ' + '(00007)';
                  } else {
                    ex.branch_name = ex.branch_name + ' (00000)';
                  }
                });
              });

              var data = [];
              result.data.forEach(function (v) {
                if (v.length > 0) {
                  data.push(v);
                }
              });
              _this.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
            } else {
              _this.$store.commit('Loading');
              _this.$notification['warning']({
                message: 'ดึงข้อมูลรายงานไม่ได้',
                description: results.message
              });
            }
          }, function (errors) {
            _this.$store.commit('Loading');
            // this.$store.commit("Loading");
            _this.$notification["warning"]({
              message: "ไม่สามารถเข้าถึงข้อมูลได้",
              description: errors.data.message
            });
          });
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format('HH:mm:ss');
    },
    bill_count: function bill_count(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['bill_count'];
      });
      return sum;
    },
    item_amount: function item_amount(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['item_amount'];
      });
      return sum;
    },
    discount_amount: function discount_amount(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['discount_amount'];
      });
      return sum;
    },
    before_tax_amount: function before_tax_amount(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['before_tax_amount'];
      });
      return sum;
    },
    tax_amount: function tax_amount(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['tax_amount'];
      });
      return sum;
    },
    total_amount: function total_amount(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['price_product_not_tax'] + val['price_product_tax'];
      });
      return sum;
    },
    count_item: function count_item(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['count_item'];
      });
      return sum;
    },
    sum_bill_count: function sum_bill_count(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          sum += val['bill_count'];
        });
      });
      return sum;
    },
    sum_discount_amount: function sum_discount_amount(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          sum += val['discount_amount'];
        });
      });
      return sum;
    },
    sum_total_amount: function sum_total_amount(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          sum += val['price_product_not_tax'] + val['price_product_tax'];
        });
      });
      return sum;
    },
    sum_count_item: function sum_count_item(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          sum += val['count_item'];
        });
      });
      return sum;
    },
    sum_item_amount: function sum_item_amount(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          sum += val['item_amount'];
        });
      });
      return sum;
    },
    cal_product_tax: function cal_product_tax(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['cal_product_tax'];
      });
      return sum;
    },
    price_product_tax: function price_product_tax(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['price_product_tax'] - val['cal_product_tax'];
      });
      return sum;
    },
    price_product_not_tax: function price_product_not_tax(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val['price_product_not_tax'];
      });
      return sum;
    },
    sum_cal_product_tax: function sum_cal_product_tax(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          sum += val['cal_product_tax'];
        });
      });
      return sum;
    },
    sum_price_product_tax: function sum_price_product_tax(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          sum += val['price_product_tax'] - val['cal_product_tax'];
        });
      });
      return sum;
    },
    sum_price_product_not_tax: function sum_price_product_not_tax(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        v.forEach(function (val) {
          sum += val['price_product_not_tax'];
        });
      });
      return sum;
    }
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.getReport()
    // }, 500)
  }
});

/***/ }),

/***/ 1133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_detail_vue__ = __webpack_require__(1119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd5197c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_detail_vue__ = __webpack_require__(1136);
function injectStyle (ssrContext) {
  __webpack_require__(1134)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bd5197c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd5197c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("533d4ae3", content, true, {});

/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".head_table[data-v-6bd5197c]{background-color:#ffffad}.head-branch[data-v-6bd5197c]{font-size:18px;color:#000;font-weight:700}.table .thead-dark th[data-v-6bd5197c]{color:#000;text-align:center;background-color:#6599ff;border-color:#383f45}.table .thead-footer th[data-v-6bd5197c]{color:#000;text-align:center;background-color:#ffff}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/components/report/report_sale_detail.vue"],"names":[],"mappings":"AACA,6BACE,wBAA0B,CAC3B,AACD,8BACE,eAAgB,AAChB,WAAoB,AACpB,eAAkB,CACnB,AACD,uCACE,WAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,oBAAsB,CACvB,AACD,yCACE,WAAe,AACf,kBAAmB,AACnB,sBAAwB,CACzB","file":"report_sale_detail.vue","sourcesContent":["\n.head_table[data-v-6bd5197c] {\n  background-color: #ffffad;\n}\n.head-branch[data-v-6bd5197c] {\n  font-size: 18px;\n  color: rgb(0, 0, 0);\n  font-weight: bold;\n}\n.table .thead-dark th[data-v-6bd5197c] {\n  color: #000000;\n  text-align: center;\n  background-color: #6599ff;\n  border-color: #383f45;\n}\n.table .thead-footer th[data-v-6bd5197c] {\n  color: #000000;\n  text-align: center;\n  background-color: #ffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_sale_detail.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_sale_detail.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm mt-3"},_vm._l((_vm.report_data),function(d,i){return _c('table',{directives:[{name:"show",rawName:"v-show",value:(d.length > 0),expression:"d.length > 0"}],key:'branchData' + i,staticClass:"table"},[_c('thead',[_c('tr',{staticClass:"head-branch text-left"},[_c('th',{attrs:{"colspan":"3"}},[_vm._v("สาขา: "+_vm._s((d.length > 0)? d[0].branch_name : '-'))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("จุดขาย: "+_vm._s(_vm.host.host_name))]),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_vm._v("วันที่: "),_c('span',[_vm._v(_vm._s(_vm.dateFormatDMY(_vm.startDate)))]),_vm._v(" "),(_vm.dateFormatDMY(_vm.startDate) !== _vm.dateFormatDMY(_vm.endDate))?_c('span',[_vm._v("ถึง วันที่: "+_vm._s(_vm.dateFormatDMY(_vm.endDate)))]):_vm._e()])])]),_vm._v(" "),_vm._l((d),function(r,i){return _c('tbody',{key:'datar' + i},[_c('tr',{staticClass:"text-left thead-dark head_table"},[_c('td',{attrs:{"colspan":"2"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_vm._v("เลขที่ใบเสร็จ: "+_vm._s(r.doc_no))]),_vm._v(" "),(_vm.users === 'admin')?_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn btn-danger btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateSale(r.doc_no)}}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ลบบิลขาย\n                      ")])]):_vm._e()])]),_vm._v(" "),_c('td',[(r.cash_amount!=0 && r.bank_amount==0)?_c('span',[_vm._v("ประเภทเงิน: เงินสด")]):_vm._e(),_vm._v(" "),(r.bank_amount!=0 && r.cash_amount==0)?_c('span',[_vm._v("ประเภทเงิน: เงินโอน")]):_vm._e(),_vm._v(" "),(r.bank_amount!= 0 && r.cash_amount!=0)?_c('span',[_vm._v("ประเภทเงิน: เงินสดและโอน")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("เวลา: "+_vm._s(_vm.dateFormatAndTime(r.create_time)))]),_vm._v(" "),_c('td',{staticClass:"text-left",attrs:{"colspan":"1"}},[_vm._v("ส่วนลดใบเสร็จ: "+_vm._s(_vm.numberFormatDecimal(r.discount_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right",attrs:{"colspan":"3"}},[_vm._v("เฉพาะราคาขาย: all")])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_vm._l((r.sub),function(sub,i){return _c('tr',{key:'subs' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(sub.item_barcode))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(sub.item_name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.price)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.cn_qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.amount - sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.amount)))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-left",attrs:{"colspan":"3"}},[_vm._v("ลูกค้า: "+_vm._s(r.ar_name || '-')+" / หมายเหตุ: "+_vm._s(r.description || '-'))]),_vm._v(" "),_c('th',{staticClass:"text-left text-danger",staticStyle:{"font-weight":"bold"}},[_vm._v("\n            เงินสด: "+_vm._s(_vm.numberFormatDecimal(r.cash_amount - r.change_amount))+"\n          ")]),_vm._v(" "),_c('th',{staticClass:"text-left text-success",staticStyle:{"font-weight":"bold"}},[_vm._v("\n            เงินโอน: "+_vm._s(_vm.numberFormatDecimal(r.bank_amount))+"\n          ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"colspan":"3"}},[_vm._v("### รวมรายการสินค้าจำนวน: "+_vm._s(r.sub.length)+" ###")])]),_vm._v(" "),_c('tr',{staticClass:"thead-footer"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"3"}},[_vm._v("พนักงานเก็บเงิน: "+_vm._s(r.create_by))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_qty(r.sub))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(0)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.total_amount - r.cal_product_tax)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.cal_product_tax)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.total_amount)))])])],2)}),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-secondary",staticStyle:{"font-size":"20px"}},[_c('th',{staticClass:"text-left",attrs:{"colspan":"7"}},[_vm._v("รวมสาขา: "+_vm._s((d.length > 0)? d[0].branch_name : '-'))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_total(d))))])])]),_vm._v(" "),(_vm.report_data.length === 0)?_c('tbody',[_vm._m(1,true)]):_vm._e()],2)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"thead-dark head_datail"},[_c('th',{attrs:{"width":"15%"}},[_vm._v("บาร์โค้ด")]),_vm._v(" "),_c('th',{staticClass:"text-left",attrs:{"width":"20%"}},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคาขาย/หน่วยนับ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคาก่อน VAT")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("ภาษี 7%")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"20%"}},[_vm._v("ราคารวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"scope":"row","colspan":"6"}},[_vm._v("ไม่มีข้อมูล")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_pos_detail_vue__ = __webpack_require__(1120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f24578_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_pos_detail_vue__ = __webpack_require__(1140);
function injectStyle (ssrContext) {
  __webpack_require__(1138)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13f24578"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_pos_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f24578_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_pos_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1139);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("dcfa33bc", content, true, {});

/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".head_table[data-v-13f24578]{background-color:#ffffad}.head-branch[data-v-13f24578]{font-size:18px;color:#000;font-weight:700}.table .thead-dark th[data-v-13f24578]{color:#000;text-align:center;background-color:#6599ff;border-color:#383f45}.table .thead-footer th[data-v-13f24578]{color:#000;text-align:center;background-color:#ffff}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/components/report/report_sale_pos_detail.vue"],"names":[],"mappings":"AACA,6BACE,wBAA0B,CAC3B,AACD,8BACE,eAAgB,AAChB,WAAoB,AACnB,eAAkB,CACpB,AACD,uCACI,WAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,oBAAsB,CACzB,AACD,yCACI,WAAe,AACf,kBAAmB,AACnB,sBAAwB,CAC3B","file":"report_sale_pos_detail.vue","sourcesContent":["\n.head_table[data-v-13f24578] {\n  background-color: #ffffad;\n}\n.head-branch[data-v-13f24578] {\n  font-size: 18px;\n  color: rgb(0, 0, 0);\n   font-weight: bold;\n}\n.table .thead-dark th[data-v-13f24578] {\n    color: #000000;\n    text-align: center;\n    background-color: #6599ff;\n    border-color: #383f45;\n}\n.table .thead-footer th[data-v-13f24578] {\n    color: #000000;\n    text-align: center;\n    background-color: #ffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_sale_pos_detail.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_sale_pos_detail.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm mt-3"},_vm._l((_vm.report_data),function(d,i){return _c('table',{directives:[{name:"show",rawName:"v-show",value:(d.length > 0),expression:"d.length > 0"}],key:'branchData' + i,staticClass:"table"},[_c('thead',[_c('tr',{staticClass:"head-branch text-left"},[_c('th',{attrs:{"colspan":"3"}},[_vm._v("สาขา: "+_vm._s((d.length > 0)? d[0].branch_name : '-'))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("จุดขาย: "+_vm._s(_vm.host.host_name))]),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_vm._v("วันที่: "),_c('span',[_vm._v(_vm._s(_vm.dateFormatDMY(_vm.startDate)))]),_vm._v(" "),(_vm.dateFormatDMY(_vm.startDate) !== _vm.dateFormatDMY(_vm.endDate))?_c('span',[_vm._v("ถึง วันที่: "+_vm._s(_vm.dateFormatDMY(_vm.endDate)))]):_vm._e()])])]),_vm._v(" "),_vm._l((d),function(r,i){return _c('tbody',{key:'datar' + i},[_c('tr',{staticClass:"text-left thead-dark head_table"},[_c('td',{attrs:{"colspan":"4"}},[_vm._v("เลขที่ใบเสร็จ: "+_vm._s(r.doc_no))]),_vm._v(" "),_c('td',[(r.cash_amount!=0 && r.bank_amount==0)?_c('span',[_vm._v("ประเภทเงิน: เงินสด")]):_vm._e(),_vm._v(" "),(r.bank_amount!=0 && r.cash_amount==0)?_c('span',[_vm._v("ประเภทเงิน: เงินโอน")]):_vm._e(),_vm._v(" "),(r.bank_amount!= 0 && r.cash_amount!=0)?_c('span',[_vm._v("ประเภทเงิน: เงินสดและโอน")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("เวลา: "+_vm._s(_vm.dateFormatAndTime(r.create_time)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("ส่วนลดใบเสร็จ: "+_vm._s(_vm.numberFormatDecimal(r.discount_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("เฉพาะราคาขาย: all")])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_vm._l((r.sub),function(sub,i){return _c('tr',{key:'subs' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(sub.item_barcode))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(sub.item_name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.price)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.cn_qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.amount - sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.amount)))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-left",attrs:{"colspan":"4"}},[_vm._v("ลูกค้า: "+_vm._s(r.ar_name || '-')+" / หมายเหตุ: "+_vm._s(r.description || '-'))]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("\n            เงินสด: "+_vm._s(_vm.numberFormatDecimal(r.cash_amount - r.change_amount))+"\n          ")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("\n            เงินโอน: "+_vm._s(_vm.numberFormatDecimal(r.bank_amount))+"\n          ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"colspan":"2"}},[_vm._v("### รวมรายการสินค้าจำนวน: "+_vm._s(r.sub.length)+" ###")])]),_vm._v(" "),_c('tr',{staticClass:"thead-footer"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"3"}},[_vm._v("พนักงานเก็บเงิน: "+_vm._s(r.create_by))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_qty(r.sub))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(0)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.total_amount - r.cal_product_tax)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.cal_product_tax)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.total_amount)))])])],2)}),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-secondary",staticStyle:{"font-size":"20px"}},[_c('th',{staticClass:"text-left",attrs:{"colspan":"7"}},[_vm._v("รวมสาขา: "+_vm._s((d.length > 0)? d[0].branch_name : '-'))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_total(d))))])])]),_vm._v(" "),(_vm.report_data.length === 0)?_c('tbody',[_vm._m(1,true)]):_vm._e()],2)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"thead-dark head_datail"},[_c('th',{attrs:{"width":"15%"}},[_vm._v("บาร์โค้ด")]),_vm._v(" "),_c('th',{staticClass:"text-left",attrs:{"width":"20%"}},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคาขาย/หน่วยนับ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคาก่อน VAT")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("ภาษี 7%")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"20%"}},[_vm._v("ราคารวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"scope":"row","colspan":"6"}},[_vm._v("ไม่มีข้อมูล")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_credit_detail_vue__ = __webpack_require__(1121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d133b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_credit_detail_vue__ = __webpack_require__(1144);
function injectStyle (ssrContext) {
  __webpack_require__(1142)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27d133b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_credit_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d133b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_credit_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1143);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("dd0bdb8c", content, true, {});

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".head_table[data-v-27d133b2]{background-color:#ffffad}.head-branch[data-v-27d133b2]{font-size:18px;color:#000;font-weight:700}.table .thead-dark th[data-v-27d133b2]{color:#000;text-align:center;background-color:#6599ff;border-color:#383f45}.table .thead-footer th[data-v-27d133b2]{color:#000;text-align:center;background-color:#ffff}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/components/report/report_sale_credit_detail.vue"],"names":[],"mappings":"AACA,6BACE,wBAA0B,CAC3B,AACD,8BACE,eAAgB,AAChB,WAAoB,AACnB,eAAkB,CACpB,AACD,uCACI,WAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,oBAAsB,CACzB,AACD,yCACI,WAAe,AACf,kBAAmB,AACnB,sBAAwB,CAC3B","file":"report_sale_credit_detail.vue","sourcesContent":["\n.head_table[data-v-27d133b2] {\n  background-color: #ffffad;\n}\n.head-branch[data-v-27d133b2] {\n  font-size: 18px;\n  color: rgb(0, 0, 0);\n   font-weight: bold;\n}\n.table .thead-dark th[data-v-27d133b2] {\n    color: #000000;\n    text-align: center;\n    background-color: #6599ff;\n    border-color: #383f45;\n}\n.table .thead-footer th[data-v-27d133b2] {\n    color: #000000;\n    text-align: center;\n    background-color: #ffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_sale_credit_detail.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_sale_credit_detail.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm mt-3"},_vm._l((_vm.report_data),function(d,i){return _c('table',{directives:[{name:"show",rawName:"v-show",value:(d.length > 0),expression:"d.length > 0"}],key:'branchData' + i,staticClass:"table"},[_c('thead',[_c('tr',{staticClass:"head-branch text-left"},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("สาขา: "+_vm._s((d.length > 0)? d[0].branch_name : '-'))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("จุดขาย: "+_vm._s(_vm.host.host_name))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("วันที่: "),_c('span',[_vm._v(_vm._s(_vm.dateFormatDMY(_vm.startDate)))]),_vm._v(" "),(_vm.dateFormatDMY(_vm.startDate) !== _vm.dateFormatDMY(_vm.endDate))?_c('span',[_vm._v("ถึง วันที่: "+_vm._s(_vm.dateFormatDMY(_vm.endDate)))]):_vm._e()])])]),_vm._v(" "),_vm._l((d),function(r,i){return _c('tbody',{key:'datar' + i},[_c('tr',{staticClass:"text-left thead-dark head_table"},[_c('td',{attrs:{"colspan":"2"}},[_vm._v("เลขที่ใบเสร็จ: "+_vm._s(r.doc_no))]),_vm._v(" "),_c('td',[_vm._v("\n            ประเภท: เงินเชื่อ\n          ")]),_vm._v(" "),_c('td',[_vm._v("เวลา: "+_vm._s(_vm.dateFormatAndTime(r.create_time)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("ส่วนลดใบเสร็จ: "+_vm._s(_vm.numberFormatDecimal(r.discount_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("เฉพาะราคาขาย: all")])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_vm._l((r.sub),function(sub,i){return _c('tr',{key:'subs' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(sub.item_barcode))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(sub.item_name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.price)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.cn_qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.amount - sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.amount)))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-left",attrs:{"colspan":"3"}},[_vm._v("ลูกค้า: "+_vm._s(r.ar_name || '-')+" / หมายเหตุ: "+_vm._s(r.description || '-'))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"colspan":"3"}},[_vm._v("### รวมรายการสินค้าจำนวน: "+_vm._s(r.sub.length)+" ###")])]),_vm._v(" "),_c('tr',{staticClass:"thead-footer"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"3"}},[_vm._v("พนักงานเก็บเงิน: "+_vm._s(r.create_by))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_qty(r.sub))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(0)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.total_amount - r.cal_product_tax)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.cal_product_tax)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.total_amount)))])])],2)}),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-secondary",staticStyle:{"font-size":"20px"}},[_c('th',{staticClass:"text-left",attrs:{"colspan":"5"}},[_vm._v("รวมสาขา: "+_vm._s((d.length > 0)? d[0].branch_name : '-'))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_total(d))))])])]),_vm._v(" "),(_vm.report_data.length === 0)?_c('tbody',[_vm._m(1,true)]):_vm._e()],2)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"thead-dark head_datail"},[_c('th',{attrs:{"width":"15%"}},[_vm._v("บาร์โค้ด")]),_vm._v(" "),_c('th',{staticClass:"text-left",attrs:{"width":"20%"}},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคาขาย/หน่วยนับ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคาก่อน VAT")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("ภาษี 7%")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"20%"}},[_vm._v("ราคารวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"scope":"row","colspan":"6"}},[_vm._v("ไม่มีข้อมูล")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_hold_detail_vue__ = __webpack_require__(1122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5529e46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_hold_detail_vue__ = __webpack_require__(1148);
function injectStyle (ssrContext) {
  __webpack_require__(1146)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5529e46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_hold_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5529e46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_hold_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("5f1e8766", content, true, {});

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".head_table[data-v-f5529e46]{background-color:#ffffad}.head-branch[data-v-f5529e46]{font-size:18px;color:#000;font-weight:700}.table .thead-dark th[data-v-f5529e46]{color:#000;text-align:center;background-color:#6599ff;border-color:#383f45}.table .thead-footer th[data-v-f5529e46]{color:#000;text-align:center;background-color:#ffff}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/components/report/report_sale_hold_detail.vue"],"names":[],"mappings":"AACA,6BACE,wBAA0B,CAC3B,AACD,8BACE,eAAgB,AAChB,WAAoB,AACnB,eAAkB,CACpB,AACD,uCACI,WAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,oBAAsB,CACzB,AACD,yCACI,WAAe,AACf,kBAAmB,AACnB,sBAAwB,CAC3B","file":"report_sale_hold_detail.vue","sourcesContent":["\n.head_table[data-v-f5529e46] {\n  background-color: #ffffad;\n}\n.head-branch[data-v-f5529e46] {\n  font-size: 18px;\n  color: rgb(0, 0, 0);\n   font-weight: bold;\n}\n.table .thead-dark th[data-v-f5529e46] {\n    color: #000000;\n    text-align: center;\n    background-color: #6599ff;\n    border-color: #383f45;\n}\n.table .thead-footer th[data-v-f5529e46] {\n    color: #000000;\n    text-align: center;\n    background-color: #ffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_sale_hold_detail.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_sale_hold_detail.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm mt-3"},_vm._l((_vm.report_data),function(d,i){return _c('table',{directives:[{name:"show",rawName:"v-show",value:(d.length > 0),expression:"d.length > 0"}],key:'branchData' + i,staticClass:"table"},[_c('thead',[_c('tr',{staticClass:"head-branch text-left"},[_c('th',{attrs:{"colspan":"3"}},[_vm._v("สาขา: "+_vm._s((d.length > 0)? d[0].branch_name : '-'))]),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_vm._v("จุดขาย: "+_vm._s(_vm.host.host_name))]),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_vm._v("วันที่: "),_c('span',[_vm._v(_vm._s(_vm.dateFormatDMY(_vm.startDate)))]),_vm._v(" "),(_vm.dateFormatDMY(_vm.startDate) !== _vm.dateFormatDMY(_vm.endDate))?_c('span',[_vm._v("ถึง วันที่: "+_vm._s(_vm.dateFormatDMY(_vm.endDate)))]):_vm._e()])])]),_vm._v(" "),_vm._l((d),function(r,i){return _c('tbody',{key:'datar' + i},[_c('tr',{staticClass:"text-left thead-dark head_table"},[_c('td',{attrs:{"colspan":"4"}},[_vm._v("เลขที่ใบเสร็จ: "+_vm._s(r.doc_no))]),_vm._v(" "),_c('td',[_vm._v("\n            ประเภท: พักบิล\n          ")]),_vm._v(" "),_c('td',[_vm._v("เวลา: "+_vm._s(_vm.dateFormatAndTime(r.create_time)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("ส่วนลดใบเสร็จ: "+_vm._s(_vm.numberFormatDecimal(r.discount_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("เฉพาะราคาขาย: all")])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_vm._l((r.sub),function(sub,i){return _c('tr',{key:'subs' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(sub.item_barcode))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(sub.item_name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.price)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.cn_qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("0.00")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.amount - sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.tax_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.amount)))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-left",attrs:{"colspan":"3"}},[_vm._v("ลูกค้า: "+_vm._s(r.ar_name || '-')+" / หมายเหตุ: "+_vm._s(r.description || '-'))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"colspan":"5"}},[_vm._v("### รวมรายการสินค้าจำนวน: "+_vm._s(r.sub.length)+" ###")])]),_vm._v(" "),_c('tr',{staticClass:"thead-footer"},[_c('td',{staticClass:"text-left",attrs:{"colspan":"3"}},[_vm._v("พนักงานเก็บเงิน: "+_vm._s(r.create_by))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_qty(r.sub))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(0)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.total_amount - r.cal_product_tax)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.cal_product_tax)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.total_amount)))])])],2)}),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"table-secondary",staticStyle:{"font-size":"20px"}},[_c('th',{staticClass:"text-left",attrs:{"colspan":"7"}},[_vm._v("รวมสาขา: "+_vm._s((d.length > 0)? d[0].branch_name : '-'))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_total(d))))])])]),_vm._v(" "),(_vm.report_data.length === 0)?_c('tbody',[_vm._m(1,true)]):_vm._e()],2)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"thead-dark head_datail"},[_c('th',{attrs:{"width":"15%"}},[_vm._v("บาร์โค้ด")]),_vm._v(" "),_c('th',{staticClass:"text-left",attrs:{"width":"20%"}},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคาขาย/หน่วยนับ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคาก่อน VAT")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("ภาษี 7%")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"20%"}},[_vm._v("ราคารวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"scope":"row","colspan":"6"}},[_vm._v("ไม่มีข้อมูล")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_summary_vue__ = __webpack_require__(1123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6198ce66_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_summary_vue__ = __webpack_require__(1150);
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_sale_summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6198ce66_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_sale_summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_sale_summary.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_sale_summary.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.report_data.length < 1}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})]),_vm._v(" "),_vm._l((_vm.report_data),function(s,i){return _c('div',{key:'datar' + i,staticClass:"table-responsive-sm mt-3"},[(s.length > 0)?_c('table',{staticClass:"table"},[_c('thead',[_c('tr',{staticClass:"text-left",staticStyle:{"font-size":"18px","font-weight":"bold"}},[_c('td',{attrs:{"colspan":"4"}},[_vm._v("สาขา: "+_vm._s(s[0].branch_name?s[0].branch_name: '-'))]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_vm._v("จุดขาย: "+_vm._s(_vm.host.host_name))])])]),_vm._v(" "),_c('tbody',[_vm._m(0,true),_vm._v(" "),_vm._l((s),function(r,i){return _c('tr',{key:'datab' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.dateFormatDMY(r.doc_date)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.bill_count)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.count_item)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.item_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.discount_amount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.price_product_not_tax)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.price_product_tax - r.cal_product_tax)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.cal_product_tax)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(r.price_product_not_tax + (r.price_product_tax))))])])}),_vm._v(" "),(s.length !== 0)?_c('tr',[_c('th',{staticClass:"text-right",attrs:{"colspan":"8"}},[_vm._v("### รวมรายการสินค้าจำนวน: "+_vm._s(s.length)+" ###")])]):_vm._e(),_vm._v(" "),(s.length !== 0)?_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("รวมรายการจุดขาย : "+_vm._s(_vm.host.host_name))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.bill_count(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.count_item(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.item_amount(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.discount_amount(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.price_product_not_tax(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.price_product_tax(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.cal_product_tax(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.total_amount(s))))])]):_vm._e(),_vm._v(" "),(s.length !== 0)?_c('tr',{staticClass:"thead-dark"},[_c('th',{staticClass:"text-center"},[_vm._v("รวมสาขา "+_vm._s(s[0].branch_name?s[0].branch_name: '-'))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.bill_count(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.count_item(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.item_amount(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.discount_amount(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.price_product_not_tax(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.price_product_tax(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.cal_product_tax(s))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.total_amount(s))))])]):_vm._e()],2),_vm._v(" "),(s.length === (i - 1))?_c('tr',{staticStyle:{"font-size":"20px","background":"#f2f2f2"}},[_c('th',[_vm._v("รวมทุกสาขา")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_bill_count(_vm.report_data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_count_item(_vm.report_data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_item_amount(_vm.report_data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_discount_amount(_vm.report_data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_price_product_not_tax(_vm.report_data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_price_product_tax(_vm.report_data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_cal_product_tax(_vm.report_data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sum_total_amount(_vm.report_data))))])]):_vm._e()]):_vm._e()])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"thead-dark text-center"},[_c('th',[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("จำนวนใบเสร็จ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("จำนวนสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ราคารวม")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("สินค้ายกเว้น VAT")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("สินค้ามี VAT")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v("ภาษีมูลค่าเพิ่ม 7%")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"20%"}},[_vm._v("ราคาสุทธิ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_pos__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_report_report_sale_detail__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_report_report_sale_pos_detail__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_report_report_sale_credit_detail__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_report_report_sale_hold_detail__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_report_report_sale_summary__ = __webpack_require__(1149);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SaleDetailView: __WEBPACK_IMPORTED_MODULE_2__components_report_report_sale_detail__["a" /* default */],
    SalePosDetailView: __WEBPACK_IMPORTED_MODULE_3__components_report_report_sale_pos_detail__["a" /* default */],
    SaleCreditDetailView: __WEBPACK_IMPORTED_MODULE_4__components_report_report_sale_credit_detail__["a" /* default */],
    SaleHoldDetailView: __WEBPACK_IMPORTED_MODULE_5__components_report_report_sale_hold_detail__["a" /* default */],
    SaleSumView: __WEBPACK_IMPORTED_MODULE_6__components_report_report_sale_summary__["a" /* default */]
  },
  data: function data() {
    return {
      tab: 99,
      host_list: [],
      host: '',
      branch: 0,
      start_date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()),
      end_date: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      hour_list: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      minute_list: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
      second_list: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
      s_h: '00',
      e_h: '23',
      s_m: '00',
      e_m: '59',
      s_s: '00',
      e_s: '59',
      start_time: '000000',
      end_time: '235959'
    };
  },

  methods: {
    getHost: function getHost() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_service_pos__["a" /* default */].getHostShift(sessionStorage.Url, this.header, function (result) {
        if (result.response === 'success') {
          _this.host_list = result.data;
          _this.host = _this.host_list[0];
          _this.tab = 0;
        } else {
          _this.alert_msg('warning', 'ดึงข้อมูลจุดขายไม่ได้', result.message);
        }
      }, function (error) {
        _this.alert_msg('error', 'ข้อมูลไม่ถูกต้อง', error.data.error);
      });
    },
    setStartTime: function setStartTime() {
      this.start_time = this.s_h + this.s_m + this.s_s;
    },
    setEndTime: function setEndTime() {
      this.end_time = this.e_h + this.e_m + this.e_s;
    }
  },
  mounted: function mounted() {
    this.getHost();
    this.getBranch();
    this.setStartTime();
    this.setEndTime();
    // setTimeout(() => {
    //   this.branch = this.$store.state.branch_list[0]
    // }, 200)
  }
});

/***/ }),

/***/ 1260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card card-solid",style:({ 'min-height': _vm.$store.state.screenHeight - 200 + 'px' })},[_c('div',{staticClass:"card-header pb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group row col-sm-6 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เลือกสาขา")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.branch),expression:"branch"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.branch=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- ทุกสาขา --")]),_vm._v(" "),_vm._l((_vm.$store.state.branch_list),function(b,i){return _c('option',{key:'branch' + i,domProps:{"value":b}},[_vm._v(_vm._s(b.branch_name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-6 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เลือกจุดขาย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.host),expression:"host"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.host=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- ทุกสาขา --")]),_vm._v(" "),_vm._l((_vm.host_list),function(h,i){return _c('option',{key:'host' + i,domProps:{"value":h}},[_vm._v(_vm._s(h.host_name))])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("จากวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},on:{"change":_vm.setStartTime},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col col-form-label text-right mb-2",attrs:{"for":"date"}},[_vm._v("เวลา")]),_vm._v(" "),_c('div',{staticClass:"col-3 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.s_h),expression:"s_h"}],staticClass:"form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.s_h=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setStartTime]}},_vm._l((_vm.hour_list),function(i){return _c('option',{key:'sh' + i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-3 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.s_m),expression:"s_m"}],staticClass:"form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.s_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setStartTime]}},_vm._l((_vm.minute_list),function(i){return _c('option',{key:'sh' + i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-3 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.s_s),expression:"s_s"}],staticClass:"form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.s_s=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setStartTime]}},_vm._l((_vm.second_list),function(i){return _c('option',{key:'sh' + i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("ถึงวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},on:{"change":_vm.setEndTime},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col col-form-label text-right mb-2",attrs:{"for":"timestart"}},[_vm._v("เวลา")]),_vm._v(" "),_c('div',{staticClass:"col-3 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.e_h),expression:"e_h"}],staticClass:"form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.e_h=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setEndTime]}},_vm._l((_vm.hour_list),function(i){return _c('option',{key:'sh' + i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-3 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.e_m),expression:"e_m"}],staticClass:"form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.e_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setEndTime]}},_vm._l((_vm.minute_list),function(i){return _c('option',{key:'sh' + i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-3 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.e_s),expression:"e_s"}],staticClass:"form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.e_s=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setEndTime]}},_vm._l((_vm.second_list),function(i){return _c('option',{key:'sh' + i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0)])])])]),_vm._v(" "),(_vm.tab == 99)?_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-3x fa-fw"})]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs mb-3"},[_c('li',{staticClass:"nav-item",on:{"click":function($event){_vm.tab = 0}}},[_c('a',{staticClass:"nav-link",class:{ 'active': _vm.tab == 0 },attrs:{"href":"javascript:void(0)"}},[_vm._v("รายงานรายละเอียดการขาย")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":function($event){_vm.tab = 1}}},[_c('a',{staticClass:"nav-link",class:{ 'active': _vm.tab == 1 },attrs:{"href":"javascript:void(0)"}},[_vm._v("รายงานรายละเอียดการขายเงินสด")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":function($event){_vm.tab = 3}}},[_c('a',{staticClass:"nav-link",class:{ 'active': _vm.tab == 3 },attrs:{"href":"javascript:void(0)"}},[_vm._v("รายงานรายละเอียดการขายพักบิล")])])]),_vm._v(" "),(_vm.tab == 0)?_c('SaleDetailView',{attrs:{"host":_vm.host,"startDate":_vm.start_date,"endDate":_vm.end_date,"startTime":_vm.start_time,"endTime":_vm.end_time,"branch":_vm.branch}}):_vm._e(),_vm._v(" "),(_vm.tab == 1)?_c('SalePosDetailView',{attrs:{"host":_vm.host,"startDate":_vm.start_date,"endDate":_vm.end_date,"startTime":_vm.start_time,"endTime":_vm.end_time,"branch":_vm.branch}}):_vm._e(),_vm._v(" "),(_vm.tab == 3)?_c('SaleHoldDetailView',{attrs:{"host":_vm.host,"startDate":_vm.start_date,"endDate":_vm.end_date,"startTime":_vm.start_time,"endTime":_vm.end_time,"branch":_vm.branch}}):_vm._e(),_vm._v(" "),(_vm.tab == 4)?_c('SaleSumView',{attrs:{"host":_vm.host,"startDate":_vm.start_date,"endDate":_vm.end_date,"branch":_vm.branch}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.b10f03393f68ec06c186.js